(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-page"] && !Shopify.designMode) return;
  try {
    
  // Single place the accordion's parts are named, so a renamed hook only changes here.
  function accountAccordionParts(accordion) {
    return {
      trigger: accordion.querySelector('[data-cms-accordion-trigger]'),
      panel: accordion.querySelector('[data-cms-accordion-panel]'),
      icon: accordion.querySelector('[data-cms-accordion-icon]'),
      content: accordion.querySelector('[data-cms-accordion-content]')
    };
  }

  function closeAccountAccordion(accordion) {
    var parts = accountAccordionParts(accordion);

    if (parts.trigger) parts.trigger.setAttribute('aria-expanded', 'false');
    if (parts.icon) parts.icon.style.transform = '';
    if (parts.content) parts.content.style.opacity = '';
    if (parts.panel) {
      parts.panel.style.gridTemplateRows = '';
      parts.panel.setAttribute('aria-hidden', 'true');
      parts.panel.setAttribute('inert', '');
    }
  }

  function openAccountAccordion(accordion) {
    var parts = accountAccordionParts(accordion);

    if (parts.trigger) parts.trigger.setAttribute('aria-expanded', 'true');
    if (parts.panel) {
      parts.panel.style.gridTemplateRows = '1fr';
      // Never aria-hidden="false" — the attribute is removed instead.
      parts.panel.removeAttribute('aria-hidden');
      parts.panel.removeAttribute('inert');
    }
    if (parts.icon) parts.icon.style.transform = 'rotate(180deg)';
    if (parts.content) parts.content.style.opacity = '1';
  }

  // Scoped to this section so it cannot double-handle if a cms-page ever shares a page.
  document.addEventListener('click', function(event) {
    if (!event.target || !event.target.closest) return;
    var trigger = event.target.closest('[data-cms-accordion-trigger]');
    if (!trigger) return;
    var accordion = trigger.closest('[data-cms-accordion]');
    if (!accordion || !accordion.closest('[data-account-page]')) return;

    if (trigger.getAttribute('aria-expanded') === 'true') {
      closeAccountAccordion(accordion);
      return;
    }

    var group = accordion.closest('[data-cms-accordion-group]');
    if (group) {
      group.querySelectorAll('[data-cms-accordion]').forEach(function(sibling) {
        if (sibling !== accordion) closeAccountAccordion(sibling);
      });
    }
    openAccountAccordion(accordion);
  });

  // Theme editor only: selecting a block reveals its content so the merchant can see it.
  document.addEventListener('shopify:block:select', function(event) {
    var accordion = event.target;
    if (!accordion || !accordion.matches) return;
    if (!accordion.matches('[data-cms-accordion]')) return;
    if (!accordion.closest('[data-account-page]')) return;
    openAccountAccordion(accordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ticking = false;
  function setBenefitsMediaState(media, state) {
    if (!media) return;
    media.removeAttribute('data-benefits-media-fixed');
    media.removeAttribute('data-benefits-media-released');
    if (state === 'fixed') {
      media.setAttribute('data-benefits-media-fixed', 'true');
    }
    if (state === 'released') {
      media.setAttribute('data-benefits-media-released', 'true');
    }
  }

  function syncBenefitsMediaPosition() {
    document.querySelectorAll('[data-benefits-section]').forEach(function (section) {
      var media = section.querySelector('[data-benefits-media]');
      var afterSection = section.nextElementSibling;
      if (!media) return;
      var sectionRect = section.getBoundingClientRect();
      var afterRect = afterSection ? afterSection.getBoundingClientRect() : null;
      var sectionReachedTop = sectionRect.top <= 0;
      var sectionFinished = sectionRect.bottom <= 0;
      if (sectionFinished) {
        setBenefitsMediaState(media, 'released');
        return;
      }
      if (sectionReachedTop) {
        setBenefitsMediaState(media, 'fixed');
        return;
      }
      setBenefitsMediaState(media, 'normal');
    });
  }

  function requestBenefitsMediaPositionSync() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      syncBenefitsMediaPosition();
    });
  }

  syncBenefitsMediaPosition();
  window.addEventListener('scroll', requestBenefitsMediaPositionSync, {
    passive: true,
  });
  window.addEventListener('resize', requestBenefitsMediaPositionSync);
  window.addEventListener('load', requestBenefitsMediaPositionSync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-custom-html"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // Wrap every pasted <table> in a scrollable div at runtime — the merchant's
    // raw HTML never carries one of its own. A table narrower than the wrapper
    // sits centred (margin-inline: auto, src/css/theme.css); a wider one (more
    // columns than fit on small screens) scrolls instead of squeezing or
    // breaking the layout. CSS alone can't add a wrapping element, hence JS.
    var entries = [];

    // Reset first: getBoundingClientRect() below must measure the wrapper's
    // un-bled position, or a previous run's negative margin would compound
    // into a growing offset on every resize instead of a fresh measurement.
    function syncOverflow() {
      entries.forEach(function (entry) {
        entry.wrapper.style.marginRight = '';
        var overflowing = entry.table.scrollWidth > entry.wrapper.clientWidth + 1;
        if (!overflowing) return;
        var gap = window.innerWidth - entry.wrapper.getBoundingClientRect().right;
        if (gap > 0) entry.wrapper.style.marginRight = (-gap) + 'px';
      });
    }

    function main() {
      document.querySelectorAll('[data-article-custom-html] table').forEach(function (table) {
        if (table.parentElement.hasAttribute('data-table-scroll')) return;
        var wrapper = document.createElement('div');
        wrapper.setAttribute('data-table-scroll', '');
        wrapper.className = 'overflow-x-auto';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
        entries.push({ table: table, wrapper: wrapper });
      });

      syncOverflow();
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncOverflow, 150);
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-related"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    function main() {
      if (!window.ProductCarouselEngine) return;
      // Shared with snippets/blog-latest-articles-carousel.liquid's own guard:
      // both target [data-blog-carousel], and a merchant can place "Latest
      // articles carousel" on an article template that already has this
      // section, so the guard property must be the same name in both files —
      // whichever script runs first claims the element, the other skips it.
      document.querySelectorAll('.blog-article-related [data-blog-carousel]').forEach(function (el) {
        if (el.__blogCarouselReady) return;
        el.__blogCarouselReady = true;
        window.ProductCarouselEngine(el, { prefix: 'data-blog-carousel' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-steps"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // Thin consumer of the shared carousel engine (assets/product-carousel-engine.js,
    // loaded once, defer, in layout/theme.liquid) — the same engine the listing
    // carousel and the PDP carousel drive under their own prefixes. This section's
    // own track/slide/arrows/prev/next attributes already match that engine's
    // prefix plus suffix convention exactly, so passing the prefix is enough and
    // the engine needs no changes. The root attribute is only server-rendered in
    // the four-or-more branch, so a static three-card row is never matched here
    // and never gets an engine attached.
    function main() {
      if (!window.ProductCarouselEngine) return;
      document.querySelectorAll('[data-blog-steps]').forEach(function (el) {
        window.ProductCarouselEngine(el, { prefix: 'data-blog-steps' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-page"] && !Shopify.designMode) return;
  try {
    
  // Single place the accordion's parts are named, so a renamed hook only changes here.
  function cmsAccordionParts(accordion) {
    return {
      trigger: accordion.querySelector('[data-cms-accordion-trigger]'),
      panel: accordion.querySelector('[data-cms-accordion-panel]'),
      icon: accordion.querySelector('[data-cms-accordion-icon]'),
      content: accordion.querySelector('[data-cms-accordion-content]')
    };
  }

  function closeCmsAccordion(accordion) {
    var parts = cmsAccordionParts(accordion);

    if (parts.trigger) parts.trigger.setAttribute('aria-expanded', 'false');
    if (parts.icon) parts.icon.style.transform = '';
    if (parts.content) parts.content.style.opacity = '';
    if (parts.panel) {
      parts.panel.style.gridTemplateRows = '';
      parts.panel.setAttribute('aria-hidden', 'true');
      parts.panel.setAttribute('inert', '');
    }
  }

  function openCmsAccordion(accordion) {
    var parts = cmsAccordionParts(accordion);

    if (parts.trigger) parts.trigger.setAttribute('aria-expanded', 'true');
    if (parts.panel) {
      parts.panel.style.gridTemplateRows = '1fr';
      // Never aria-hidden="false" — the attribute is removed instead.
      parts.panel.removeAttribute('aria-hidden');
      parts.panel.removeAttribute('inert');
    }
    if (parts.icon) parts.icon.style.transform = 'rotate(180deg)';
    if (parts.content) parts.content.style.opacity = '1';
  }

  // Delegated so rows added or re-rendered in the theme editor stay live.
  document.addEventListener('click', function(event) {
    if (!event.target || !event.target.closest) return;
    var trigger = event.target.closest('[data-cms-accordion-trigger]');
    if (!trigger) return;
    var accordion = trigger.closest('[data-cms-accordion]');
    if (!accordion) return;

    if (trigger.getAttribute('aria-expanded') === 'true') {
      closeCmsAccordion(accordion);
      return;
    }

    var group = accordion.closest('[data-cms-accordion-group]');
    if (group) {
      group.querySelectorAll('[data-cms-accordion]').forEach(function(sibling) {
        if (sibling !== accordion) closeCmsAccordion(sibling);
      });
    }
    openCmsAccordion(accordion);
  });

  // Theme editor only: selecting a block reveals its content so the merchant can see it.
  document.addEventListener('shopify:block:select', function(event) {
    var accordion = event.target;
    if (!accordion || !accordion.matches) return;

    if (accordion.matches('[data-cms-accordion]')) {
      openCmsAccordion(accordion);
      return;
    }

    // Selecting a rate table (or a row inside it) switches to it.
    var table = accordion.closest('[data-rate-table]');
    if (table) showRateTable(table.closest('[data-rate-group]'), table.id);
  });

  // The theme editor replaces this markup on every keystroke, so the open table cannot live in the DOM alone.
  var openRateTables = {};

  // Built once but read on each use, so changing the OS setting mid-session still counts.
  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Every table is hidden in Liquid, so this is also what reveals the first one on load.
  function showRateTable(group, tableId) {
    if (!group || !tableId) return;

    var groupKey = group.getAttribute('data-rate-group');
    if (groupKey) openRateTables[groupKey] = tableId;

    var openLabel = '';

    group.querySelectorAll('[data-rate-table]').forEach(function(table) {
      if (table.id !== tableId) {
        table.setAttribute('hidden', '');
        return;
      }

      openLabel = table.getAttribute('data-rate-label') || '';

      var wasHidden = table.hasAttribute('hidden');
      table.removeAttribute('hidden');

      // display:none can't transition, so paint at opacity 0 first, then let transition-fade run.
      if (wasHidden && !(reduceMotionQuery && reduceMotionQuery.matches)) {
        table.style.opacity = '0';
        void table.offsetHeight;
        table.style.opacity = '';
      }
    });

    var select = group.querySelector('[data-rate-select]');
    var label = group.querySelector('[data-rate-select-label]');
    if (select) select.value = tableId;
    // Read from the table, not the select's own option, so the visible text can never drift from what is shown.
    if (label) label.textContent = openLabel;
  }

  // Builds the switcher's options from the tables themselves, since a parent block cannot read its children's settings.
  function initRateGroups() {
    document.querySelectorAll('[data-rate-group]').forEach(function(group) {
      var switcher = group.querySelector('[data-rate-switcher]');
      var select = group.querySelector('[data-rate-select]');
      if (!switcher || !select) return;

      var tables = group.querySelectorAll('[data-rate-table]');
      select.textContent = '';

      tables.forEach(function(table) {
        var option = document.createElement('option');
        option.value = table.id;
        option.text = table.getAttribute('data-rate-label') || '';
        select.appendChild(option);
      });

      // One table is nothing to switch between, so the control stays out of the way.
      if (tables.length > 1) switcher.removeAttribute('hidden');
      else switcher.setAttribute('hidden', '');

      if (!tables.length) return;

      // Reopen the table the merchant was on, so editing a setting does not throw them back to the first one. A deleted table falls through.
      var remembered = openRateTables[group.getAttribute('data-rate-group')];
      var stillThere = Array.prototype.some.call(tables, function(table) { return table.id === remembered; });
      showRateTable(group, stillThere ? remembered : tables[0].id);
    });
  }

  document.addEventListener('change', function(event) {
    if (!event.target || !event.target.matches) return;
    if (!event.target.matches('[data-rate-select]')) return;
    showRateTable(event.target.closest('[data-rate-group]'), event.target.value);
  });

  initRateGroups();
  document.addEventListener('shopify:section:load', initRateGroups);

  // Three things Shopify Forms styles from inside its shadow root that no custom property reaches.
  function styleFormsEmbed() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    if (host.__whittardFormStyled) return true;

    // Selectors are the app's own hooks or standard attributes, never its hashed class names. Theme tokens resolve here because custom properties inherit through the shadow boundary.
    var sheet = new CSSStyleSheet();
    sheet.replaceSync(
      // The app draws the error ring with a positive spread, so the container clips it; inset does not.
      '[aria-invalid="true"] { box-shadow: inset 0 0 0 2px var(--form-error-color) !important; }' +
      // The textarea is shorter than its field, so an inset ring would start partway down — draw it outside, plus one inset ring on the right, the only side the container clips.
      'textarea { box-shadow: 0 0 0 1px var(--color-border-secondary), inset -1px 0 0 0 var(--color-border-secondary) !important; }' +
      // Below 490px the app centres the form in a fixed grid column, leaving it ~281px inside a 382px container.
      '@media screen and (max-width: 490px) {' +
      '  [data-testid="app-router"] { display: flex !important; }' +
      '  [data-sizing="form-wrapper"] { width: 100% !important; }' +
      '}' +
      // The country button pads evenly around a 16px flag while the phone input pads 1.5x/0.5x around 20.3px of text, so it ends 4.3px short of it whatever --form-field-padding is.
      // min-height, not height: the app declares height on the button and wins it; it declares neither of these two, so no !important is needed here.
      '.phone-country-selector > * { height: 100%; }' +
      '.phone-country-selector button { min-height: 100%; }' +
      // The Reason for contact toggle carries a hardcoded 46px while every input resolves to 50.3 from --form-field-padding, leaving it 4.3px short of the fields it stacks against.
      // min-height over the app's own height, and the b2 line box is the forms body font it already uses, so the field tracks whatever padding the app ships; [aria-labelledby] scopes it to the labelled selects, never the country button above.
      '[class*="_selectToggle_"][aria-labelledby] { min-height: calc(var(--form-field-padding) * 2 + var(--font-size-b2) * var(--leading-b2)); }' +
      // Figma spaces the fields 8px apart; the app ships 12. Changing this also changes the embed's own top offset, which the block gap in the stylesheet below is calculated against.
      // Matched on the app's own data-testid rather than a bare `form`, which loses to the hashed class the app sets the gap on — specificity instead of !important.
      'form[data-testid="form"] { row-gap: var(--spacing-8); }' +
      // The confirmation banner's heading renders at calc(--heading-font-size * 0.8) = 17.6px on a hardcoded 26px line, against Figma's 22/28.6 below 1024 and 24/31.2 above, with 16px under it rather than 5.
      // The module name is matched, never its hash, and h2[class] outweighs the app's own two-class rule without !important. --heading-font-size is left alone: the app's pop-up teaser reads it too.
      '[class*="formBanner"] h2[class] {' +
      '  font-size: var(--font-size-d4-step);' +
      '  line-height: var(--leading-d4);' +
      '  margin-bottom: var(--spacing-16);' +
      '}' +
      '@media screen and (min-width: 1024px) {' +
      '  [class*="formBanner"] h2[class] { font-size: var(--font-size-d4-step-xl); }' +
      '}' +
      // The banner's message is a bare div next to that heading, with no rule of the app's own, so it inherits 14px/#1d1d1d against Figma's 15px/21px/#616161 — the theme's b1 + secondary.
      '[class*="formBanner"] > div {' +
      '  font-size: var(--font-size-b1);' +
      '  line-height: var(--leading-b1);' +
      '  color: var(--color-secondary);' +
      '}' +
      // From 1024 up Figma holds that message to 361px centred inside the 763px column (node 14818:53457) instead of letting it run full width; below 1024 it fills the column (node 14818:53398). 366 is the nearest token, and the one the contact block already uses.
      '@media screen and (min-width: 1024px) {' +
      '  [class*="formBanner"] > div { max-width: var(--spacing-366); margin-inline: auto; }' +
      '}' +
      // Figma keeps the form's box after submit and centres the confirmation inside it — 173px of air above and below at 1366. The app collapses the box to the banner instead, so the height recorded below is held here.
      // Keyed on the app's own data-current-step, so it covers whatever it calls the post-submit step.
      // align-content, not align-items: the root carries an empty sibling div, so a grid stretches two rows and centres the banner inside the lower one instead of centring the pair.
      '[data-form-root]:not([data-current-step="form"]) {' +
      '  min-height: var(--whittard-form-height, auto);' +
      '  display: grid;' +
      '  align-content: center;' +
      '}'
    );

    // !important rather than relying on order: the app keeps appending its own sheets after this runs.
    host.shadowRoot.adoptedStyleSheets = [...host.shadowRoot.adoptedStyleSheets, sheet];

    // Records the form's height for the rule above, and only while the form is the current step — so the value left behind is the form's, not the banner's.
    var root = host.shadowRoot.querySelector('[data-form-root]');
    if (root && window.ResizeObserver) {
      new ResizeObserver(function() {
        if (root.getAttribute('data-current-step') !== 'form') return;
        host.style.setProperty('--whittard-form-height', root.offsetHeight + 'px');
      }).observe(root);
    }

    host.__whittardFormStyled = true;
    return true;
  }

  // The form mounts asynchronously, and its shadow content is invisible to a MutationObserver, so poll — capped at 10s.
  function watchFormsEmbed() {
    if (!window.CSSStyleSheet || styleFormsEmbed()) return;

    var attempts = 0;
    var timer = setInterval(function() {
      attempts++;
      if (styleFormsEmbed() || attempts > 40) clearInterval(timer);
    }, 250);
  }

  watchFormsEmbed();
  document.addEventListener('shopify:section:load', watchFormsEmbed);

  // Figma keeps the current page in the tab row at its fixed position, so late in the menu it starts off screen and the row gives no sense of place (Faye, Figma comment 2026-09-08).
  function revealActiveCmsTab() {
    var nav = document.querySelector('.cms-page-nav');
    // Only the mobile/tablet row scrolls; from 1024 the nav is a static column and scrollWidth never exceeds clientWidth.
    if (!nav || nav.scrollWidth <= nav.clientWidth) return;

    var active = nav.querySelector('[aria-current="page"]');
    if (!active) return;

    var navBox = nav.getBoundingClientRect();
    var tabBox = active.getBoundingClientRect();
    // Figma draws the row unscrolled, so a tab already within the first screenful is left where it is; only move one that is genuinely out of sight.
    if (tabBox.left >= navBox.left && tabBox.right <= navBox.right) return;

    // Lands it where the first tab sits at rest, just inside the row's own padding; the browser clamps this at the end of the track.
    nav.scrollLeft += tabBox.left - navBox.left - parseFloat(getComputedStyle(nav).paddingLeft);
  }

  // Tab widths come from a webfont, so measuring before it lands scrolls to a stale offset.
  function watchActiveCmsTab() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(revealActiveCmsTab);
    } else {
      revealActiveCmsTab();
    }
  }

  watchActiveCmsTab();
  document.addEventListener('shopify:section:load', watchActiveCmsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var intervalIds = [];
    var UNIT_ORDER = ['days', 'hours', 'minutes', 'seconds'];

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    /* Accepts "2026-12-24T18:00", "2026-12-24 18:00", or a full ISO string with an
       offset ("2026-12-24T18:00:00+00:00" / "...Z"). With no offset given, the
       store's current UTC offset (rendered by Liquid) is appended so every shopper
       counts down to the same instant. Note: that offset is the store's offset at
       render time, so a countdown that crosses a GMT/BST change can be out by an
       hour — enter an explicit offset in that case. */
    function parseEnd(root) {
      var raw = (root.getAttribute('data-countdown-end') || '').trim().replace(' ', 'T');
      var offset = root.getAttribute('data-countdown-offset') || '+00:00';

      if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(raw)) {
        if (/T\d{2}:\d{2}$/.test(raw)) raw += ':00';
        raw += offset;
      }

      var time = new Date(raw).getTime();
      return isNaN(time) ? null : time;
    }

    function clearAll() {
      intervalIds.forEach(function (id) {
        window.clearInterval(id);
      });
      intervalIds = [];
    }

    function initCountdowns() {
      clearAll();

      var inEditor = window.Shopify && window.Shopify.designMode;

      document.querySelectorAll('[data-countdown]').forEach(function (root) {
        var end = parseEnd(root);

        if (end === null) {
          console.warn('Countdown banner: could not read end date', root.getAttribute('data-countdown-end'));
          return;
        }

        var hideOnEnd = root.getAttribute('data-countdown-hide-on-end') === 'true';
        var values = {};
        var wraps = {};

        UNIT_ORDER.forEach(function (unit) {
          values[unit] = root.querySelector('[data-countdown-unit="' + unit + '"]');
          wraps[unit] = root.querySelector('[data-countdown-unit-wrap="' + unit + '"]');
        });

        /* Writes the numbers and hides LEADING zero units only: "0 days" goes,
           then "00 hrs" once there are no days left, and so on. A zero in the
           middle ("1 day 00 hrs 12 mins") stays, otherwise units would blink in
           and out every minute and shift the layout. Seconds always show. */
        function render(totalSeconds) {
          var parts = {
            days: Math.floor(totalSeconds / 86400),
            hours: Math.floor((totalSeconds % 86400) / 3600),
            minutes: Math.floor((totalSeconds % 3600) / 60),
            seconds: totalSeconds % 60,
          };
          var leading = true;

          UNIT_ORDER.forEach(function (unit) {
            values[unit].textContent = unit === 'days' ? parts[unit] : pad(parts[unit]);

            if (unit !== 'seconds' && leading && parts[unit] === 0) {
              wraps[unit].hidden = true;
            } else {
              leading = false;
              wraps[unit].hidden = false;
            }
          });
        }

        function finish() {
          /* In the theme editor, never hide the section entirely — the merchant
             needs to be able to see and click it. */
          if (hideOnEnd && !inEditor) {
            root.hidden = true;
            return;
          }
          render(0);
        }

        /* Returns false once the countdown has finished. */
        function tick() {
          var remaining = end - Date.now();

          if (remaining <= 0) {
            finish();
            return false;
          }

          render(Math.floor(remaining / 1000));
          return true;
        }

        if (!tick()) return;

        var intervalId = window.setInterval(function () {
          if (!tick()) window.clearInterval(intervalId);
        }, 1000);

        intervalIds.push(intervalId);
      });
    }

    initCountdowns();

    /* Theme editor swaps the section's DOM on edit — rebuild the timers. */
    document.addEventListener('shopify:section:load', initCountdowns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavour-category"] && !Shopify.designMode) return;
  try {
    
(function () {
  var _cs         = getComputedStyle(document.documentElement);
  var EASING      = _cs.getPropertyValue('--ease-both').trim() || 'cubic-bezier(0.77,0,0.01,1)';
  var DURATION    = Math.round((parseFloat(_cs.getPropertyValue('--duration-a3')) || 0.3) * 1000);
  var BG_EASING   = 'ease';
  var BG_DURATION = Math.round((parseFloat(_cs.getPropertyValue('--duration-a6')) || 0.5) * 1000);

  // Animate element opacity using WAAPI. commitStyles() captures the live
  // mid-animation value into inline style before cancel() snaps back, so
  // rapid reversals always start from the correct visual position.
  function fadeEl(el, toOpacity) {
    el.getAnimations().forEach(function (a) {
      try { a.commitStyles(); } catch (e) {}
      a.cancel();
    });
    var from = parseFloat(getComputedStyle(el).opacity);
    if (Math.abs(from - toOpacity) < 0.001) return;
    var anim = el.animate(
      [{ opacity: from }, { opacity: toOpacity }],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
    anim.onfinish = function () {
      el.style.opacity = String(toOpacity);
      anim.cancel();
    };
  }

  function FlavourCategory(section) {
    var allTabs       = Array.from(section.querySelectorAll('[data-flavour-tab]'));
    var panels        = Array.from(section.querySelectorAll('[data-flavour-panel]'));
    var bgs           = Array.from(section.querySelectorAll('[data-flavour-bg]'));
    var scrollWrap    = section.querySelector('[data-flavour-scroll-wrapper]');
    var scrollWrapMob = section.querySelector('[data-flavour-scroll-wrapper-mob]');
    var rightEl       = section.querySelector('[data-flavour-right]');
    var mobRightEl    = section.querySelector('[data-flavour-mob-right]');
    var mobStickyEl   = section.querySelector('[data-flavour-mob-sticky]');
    var mobHeaderEl   = section.querySelector('[data-flavour-mob-header]');
    var desktopEl     = section.querySelector('[data-flavour-desktop]');

    if (!allTabs.length) return;

    // Pre-measure italic width to lock minWidth and prevent layout shift on state changes.
    // Seed inline opacity from the Liquid-rendered class so WAAPI has a reliable "from" value.
    allTabs.forEach(function (tab) {
      var normal = tab.offsetWidth;
      tab.style.fontStyle = 'italic';
      var italic = tab.offsetWidth;
      tab.style.fontStyle = '';
      tab.style.minWidth = Math.max(normal, italic) + 'px';
      tab.style.opacity  = tab.classList.contains('italic') ? '1' : '0.6';
    });

    var activeId      = (section.querySelector('[data-flavour-tab][aria-selected="true"]') || allTabs[0]).dataset.flavourTab;
    var headingEl     = section.querySelector('[data-flavour-heading]');
    var mobHeadingEl  = section.querySelector('[data-flavour-mob-heading]');
    var deskTablist   = section.querySelector('[data-flavour-left] [data-flavour-tablist]');
    var mobTablist    = section.querySelector('[data-flavour-scroll-wrapper-mob] [data-flavour-tablist]');
    var ctaWrap       = section.querySelector('[data-flavour-cta]');
    var ctaEl         = ctaWrap ? ctaWrap.querySelector('a, button') : null;

    function isDesktop() { return window.innerWidth >= 1024; }
    function getScrollWrapper() { return isDesktop() ? scrollWrap : scrollWrapMob; }
    function getRightEl() { return isDesktop() ? rightEl : mobRightEl; }

    function getActivePanel() {
      var re = getRightEl();
      return re ? re.querySelector('[data-flavour-panel="' + activeId + '"]') : null;
    }

    function getAvailableHeight() {
      if (isDesktop()) return window.innerHeight;
      var headerH = mobHeaderEl ? mobHeaderEl.offsetHeight : 0;
      return window.innerHeight - headerH;
    }

    var cachedMaxScroll = 0;

    function updateWrapperHeight() {
      var wrapper = getScrollWrapper();
      if (!wrapper) return;
      var panel = getActivePanel();
      if (!panel) return;
      var availH = getAvailableHeight();
      cachedMaxScroll = Math.max(0, panel.scrollHeight - availH);

      if (isDesktop() && cachedMaxScroll === 0) {
        wrapper.style.height = panel.scrollHeight + 'px';
        if (desktopEl) desktopEl.style.height = panel.scrollHeight + 'px';
      } else if (!isDesktop() && cachedMaxScroll === 0) {
        // Panel fits without scrolling — shrink the sticky container and wrapper to
        // content height so no empty background gap appears below the products.
        var headerH = mobHeaderEl ? mobHeaderEl.offsetHeight : 0;
        var contentH = headerH + panel.scrollHeight;
        wrapper.style.height = contentH + 'px';
        if (mobStickyEl) mobStickyEl.style.height = contentH + 'px';
      } else {
        wrapper.style.height = (window.innerHeight + cachedMaxScroll) + 'px';
        if (desktopEl) desktopEl.style.height = '';
        if (mobStickyEl) mobStickyEl.style.height = '';
      }
    }

    function onPageScroll() {
      var wrapper = getScrollWrapper();
      if (!wrapper) return;
      var panel = getActivePanel();
      if (!panel) return;
      var rect       = wrapper.getBoundingClientRect();
      var scrolledIn = Math.max(0, -rect.top);
      panel.style.transform = 'translateY(-' + Math.min(scrolledIn, cachedMaxScroll) + 'px)';
    }

    function showBg(blockId) {
      bgs.forEach(function (bg) {
        bg.getAnimations().forEach(function (a) {
          try { a.commitStyles(); } catch (e) {}
          a.cancel();
        });
      });

      var targets = bgs.filter(function (bg) { return bg.dataset.flavourBg === blockId; });
      if (!targets.length) return;

      // Only the shown background may play its video: the stacked ones sit at opacity 0
      // but are still laid out and in view, so the shared gate cannot tell on its own.
      bgs.forEach(function (bg) {
        if (bg.dataset.flavourBg === blockId) {
          bg.removeAttribute('data-background-video-inactive');
        } else {
          bg.setAttribute('data-background-video-inactive', '');
        }
      });
      document.dispatchEvent(new CustomEvent('background-video:sync'));

      bgs.forEach(function (bg) {
        if (bg.dataset.flavourBg === blockId) {
          bg.style.zIndex = '1';
        } else {
          bg.style.zIndex = '';
          var op = parseFloat(bg.style.opacity || '0');
          if (op > 0 && op < 0.999) bg.style.opacity = '0';
        }
      });

      var done = 0;
      targets.forEach(function (target) {
        var from = parseFloat(getComputedStyle(target).opacity);
        if (Math.abs(from - 1) < 0.001) {
          done++;
          if (done === targets.length) {
            bgs.forEach(function (bg) { if (bg.dataset.flavourBg !== blockId) bg.style.opacity = '0'; });
          }
          return;
        }
        var anim = target.animate(
          [{ opacity: from }, { opacity: 1 }],
          { duration: BG_DURATION, easing: BG_EASING, fill: 'forwards' }
        );
        anim.onfinish = function () {
          target.style.opacity = '1';
          anim.cancel();
          done++;
          if (done === targets.length) {
            bgs.forEach(function (bg) { if (bg.dataset.flavourBg !== blockId) bg.style.opacity = '0'; });
          }
        };
      });
    }

    var DARK_BTN  = ['text-invert',  'shadow-btn-indicator-dark',  'hover:shadow-btn-indicator-dark-hover',  'focus-visible:outline-invert'];
    var LIGHT_BTN = ['text-primary', 'shadow-btn-indicator-light', 'hover:shadow-btn-indicator-light-hover', 'focus-visible:outline-primary'];

    function applyTheme(blockId, instant) {
      var anyTab   = section.querySelector('[data-flavour-tab="' + blockId + '"]');
      var inverted = anyTab && anyTab.dataset.flavourInvert === 'true';

      var colorTrans = instant ? 'none' : 'color ' + (BG_DURATION / 1000) + 's ' + BG_EASING;

      [headingEl, mobHeadingEl].forEach(function (el) {
        if (el) el.style.transition = colorTrans;
      });

      if (ctaEl) ctaEl.style.transition = colorTrans;

      [headingEl, mobHeadingEl].forEach(function (el) {
        if (!el) return;
        el.classList.toggle('text-invert', !inverted);
        el.classList.toggle('text-primary',  inverted);
      });

      [deskTablist, mobTablist].forEach(function (tablist) {
        if (!tablist) return;
        tablist.querySelectorAll('[data-flavour-tab]').forEach(function (t) {
          t.style.color = '';
          t.classList.toggle('text-invert', !inverted);
          t.classList.toggle('text-primary',  inverted);
        });
      });

      if (ctaEl) {
        var remove = inverted ? DARK_BTN  : LIGHT_BTN;
        var add    = inverted ? LIGHT_BTN : DARK_BTN;
        remove.forEach(function (c) { ctaEl.classList.remove(c); });
        add.forEach(function (c)    { ctaEl.classList.add(c); });
      }

      requestAnimationFrame(function () {
        if (instant) {
          [headingEl, mobHeadingEl].forEach(function (el) {
            if (el) el.style.transition = '';
          });
          if (ctaEl) ctaEl.style.transition = '';
        }
      });
    }

    function setActive(blockId) {
      allTabs.forEach(function (tab) {
        var on = tab.dataset.flavourTab === blockId;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.classList.toggle('italic',     on);
        tab.classList.toggle('not-italic', !on);
        // Cancel any in-flight WAAPI and snap to final opacity
        tab.getAnimations().forEach(function (a) { a.cancel(); });
        tab.style.opacity = on ? '1' : '0.6';
      });

      panels.forEach(function (panel) {
        var on = panel.dataset.flavourPanel === blockId;
        panel.hidden = !on;
        if (on) panel.style.transform = '';
      });

      showBg(blockId);
      applyTheme(blockId);

      var wrapper = getScrollWrapper();
      if (wrapper) {
        var rect = wrapper.getBoundingClientRect();
        if (rect.top < -1) window.scrollTo(0, window.pageYOffset + rect.top);
      }

      updateWrapperHeight();
      onPageScroll();
    }

    allTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeId = tab.dataset.flavourTab;
        setActive(activeId);
      });
    });

    section.querySelectorAll('[data-flavour-tablist]').forEach(function (tablist) {
      var listTabs = Array.from(tablist.querySelectorAll('[data-flavour-tab]'));
      tablist.addEventListener('keydown', function (e) {
        var idx = listTabs.indexOf(document.activeElement);
        if (idx === -1) return;
        var next;
        if      (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % listTabs.length;
        else if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   next = (idx - 1 + listTabs.length) % listTabs.length;
        else if (e.key === 'Home')  next = 0;
        else if (e.key === 'End')   next = listTabs.length - 1;
        else return;
        e.preventDefault();
        listTabs[next].focus();
        activeId = listTabs[next].dataset.flavourTab;
        setActive(activeId);
      });
    });

    allTabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        showBg(tab.dataset.flavourTab);
        applyTheme(tab.dataset.flavourTab);
        if (tab.dataset.flavourTab !== activeId) {
          tab.classList.add('italic');
          tab.classList.remove('not-italic');
          fadeEl(tab, 1);
        }
      });

      tab.addEventListener('mouseleave', function (e) {
        if (!isDesktop()) return;
        if (tab.dataset.flavourTab !== activeId) {
          tab.classList.remove('italic');
          tab.classList.add('not-italic');
          fadeEl(tab, 0.6);
        }

        var movingToTab = e.relatedTarget && deskTablist && deskTablist.contains(e.relatedTarget);
        if (!movingToTab) {
          applyTheme(activeId, true);
        }
      });
    });

    if (deskTablist) {
      deskTablist.addEventListener('mouseleave', function () {
        showBg(activeId);
        applyTheme(activeId, true);
      });
    }

    window.addEventListener('scroll', onPageScroll, { passive: true });
    window.addEventListener('resize', function () {
      updateWrapperHeight();
      onPageScroll();
    });

    if (window.ResizeObserver) {
      [rightEl, mobRightEl].filter(Boolean).forEach(function (el) {
        new ResizeObserver(function () {
          updateWrapperHeight();
          onPageScroll();
        }).observe(el);
      });
    }

    requestAnimationFrame(function () {
      updateWrapperHeight();
      onPageScroll();
      applyTheme(activeId, true);
    });
  }

  function init() {
    document.querySelectorAll('[data-flavour-section]').forEach(function (el) {
      new FlavourCategory(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    // Cookie settings control — re-opens the OneTrust preference centre, which is
    // otherwise unreachable once the banner has been dismissed (GDPR Art. 7(3)), and
    // is the persistent US opt-out entry point CPRA asks for.
    //
    // Bound here rather than by adding OneTrust's own `.ot-sdk-show-settings` class:
    // this theme keeps classes for styling and data-* for JS hooks, and a single code
    // path also rules out the double-toggle you get when both bindings fire.
    //
    // ToggleInfoDisplay() is OneTrust's public API and is verified working on this
    // storefront. If OneTrust never loaded, fall back to the cookie policy carried on
    // the attribute rather than leaving a dead control.
    document.querySelectorAll('[data-cookie-settings]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ot = window.OneTrust;
        if (ot && typeof ot.ToggleInfoDisplay === 'function') {
          ot.ToggleInfoDisplay();
          return;
        }
        var fallback = btn.getAttribute('data-cookie-settings');
        if (fallback) window.location.href = fallback;
      });
    });

    // Sign-up button: full opacity once email is populated
    document.querySelectorAll('[id^="FooterEmail-"]').forEach(function(input) {
      var btn = input.closest('form').querySelector('.footer-signup-btn');
      if (!btn) return;
      input.addEventListener('input', function() {
        btn.style.opacity = input.value.trim() ? '1' : '';
      });
    });

    // Footer reveal: measure height, pin to the viewport bottom once the
    // footer's bottom edge arrives, pan if the footer is taller than the
    // screen. Runs at every breakpoint (design sign-off: Faye).
    //
    // Panning writes `transform`, never `bottom`, on the pinned
    // (position:fixed) element — `bottom` triggers layout on every scroll
    // frame, which is what caused the "jitters on scroll" that got the
    // previous version of this reveal reverted (TASK-51293 / PR #13).
    // `transform` is compositor-only.
    //
    // viewportHeight() reads window.innerHeight, not visualViewport.height:
    // visualViewport shrinks when the on-screen keyboard opens, and the
    // footer's own newsletter input can trigger that — using it here would
    // reflow the spacer/pin geometry mid-typing.
    (function() {
      var root = document.querySelector('[data-footer-reveal]');
      var slot = root && root.querySelector('[data-footer-reveal-slot]');
      // Resolve the measured/pinned wrapper by identity, never by DOM order:
      // walk up from this section's own stamp to the group wrapper containing
      // it. `.shopify-section-group-footer-group` alone matches two siblings
      // in the slot (this section + the Orbe Apps section, D35), and a plain
      // querySelector would take whichever `footer-group.json`'s `order` array
      // happens to list first, silently retargeting every measurement at the
      // empty Apps wrapper if a merchant reorders the group.
      var target = slot && slot.querySelector('[data-footer-reveal-target]');
      var footerGroup = target && target.closest('.shopify-section-group-footer-group');
      var mainContent = document.getElementById('main-content');
      if (!root || !slot || !footerGroup || !mainContent) return;

      var overflow = 0;
      var height = 0;
      var pinned = false;
      var ticking = false;
      var debounceTimer;

      function viewportHeight() {
        return window.innerHeight;
      }

      function syncMetrics() {
        height = footerGroup.offsetHeight;
        overflow = Math.max(0, height - viewportHeight());
        root.style.setProperty('--footer-height', height + 'px');
        root.style.setProperty('--footer-overflow', overflow + 'px');
        if (pinned) slot.style.height = height + 'px';
        updatePin();
      }

      function updatePin() {
        var vh = viewportHeight();
        var shouldPin = slot.getBoundingClientRect().bottom <= vh;
        if (shouldPin !== pinned) {
          pinned = shouldPin;
          if (pinned) {
            slot.style.height = height + 'px';
            footerGroup.style.position = 'fixed';
            footerGroup.style.left = '0';
            footerGroup.style.width = '100%';
            footerGroup.style.bottom = '0';
            footerGroup.style.willChange = 'transform';
          } else {
            slot.style.height = '';
            footerGroup.style.position = '';
            footerGroup.style.left = '';
            footerGroup.style.width = '';
            footerGroup.style.bottom = '';
            footerGroup.style.transform = '';
            footerGroup.style.willChange = '';
          }
        }
        if (pinned) {
          var pan = 0;
          if (overflow > 0) {
            var mainBottom = mainContent.getBoundingClientRect().bottom;
            if (mainBottom < 0) pan = Math.min(overflow, -mainBottom);
          }
          footerGroup.style.transform = pan ? 'translateY(' + pan + 'px)' : '';
        }
        ticking = false;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updatePin);
      }

      function onResize() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          requestAnimationFrame(syncMetrics);
        }, 300);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
      new ResizeObserver(onResize).observe(footerGroup);

      // A tab backgrounded mid-scroll (app switch, lock screen) can drop the
      // rAF `onScroll` just scheduled — the browser suspends rAF callbacks
      // for hidden documents. Without this, `ticking` stays true forever and
      // the reveal permanently stops responding to scroll. Resync on
      // visibility return.
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          ticking = false;
          syncMetrics();
        }
      });

      syncMetrics();

      // iOS re-scrolls to the form anchor after us, so assert the uncovered state until it holds rather than write one offset.
      (function() {
        var msg = document.querySelector('[data-footer-signup-success], [data-footer-signup-error]');
        if (!msg || !mainContent) return;

        var deadline = Date.now() + 2000;
        var released = false;
        function release() { released = true; }
        ['touchstart', 'wheel', 'keydown'].forEach(function(type) {
          window.addEventListener(type, release, { passive: true, once: true });
        });

        // clientHeight, not innerHeight: on iOS innerHeight ignores the toolbars and calls a hidden message visible.
        function settled() {
          var rect = msg.getBoundingClientRect();
          return rect.top >= mainContent.getBoundingClientRect().bottom &&
                 rect.top >= 0 &&
                 rect.bottom <= document.documentElement.clientHeight;
        }

        function assert() {
          if (released || Date.now() > deadline) return;
          if (!settled()) window.scrollTo(0, document.documentElement.scrollHeight);
          requestAnimationFrame(assert);
        }
        requestAnimationFrame(assert);
      })();
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  /* Search ticker moved to header-search.liquid (that snippet owns the
     data-search-ticker markup — D27). */

  /* ═══════════════════════════════════════════════
     Cart badge sync
     Other cart-mutating surfaces (e.g. the mini bag drawer) dispatch this
     event on the document — header.liquid owns this markup, so it updates
     its own badge/aria-label here rather than relying on another section.
  ═══════════════════════════════════════════════ */
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('hidden', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-label-template]').forEach(function (link) {
      var template = link.getAttribute('data-cart-label-template');
      link.setAttribute('aria-label', template.replace('__CART_COUNT__', cart.item_count));
    });
  });

  /* ═══════════════════════════════════════════════
     Sticky scrollback controller
     Uses inline style.transform — no CSS class required.
  ═══════════════════════════════════════════════ */
  (function() {
    var header         = document.getElementById('site-header');
    var mobileSearchRow = document.querySelector('[data-mobile-search-row]');
    if (!header) return;

    // #header-spacer only exists on templates NOT overlaying a hero (see
    // layout/theme.liquid's needs_spacer) — on those, the hide has no
    // reveal-effect to protect, so it skips the eased transition entirely.
    var hasSpacer       = !!document.getElementById('header-spacer');
    var lastScrollY     = window.scrollY;
    var ticking         = false;
    var isHidden        = false;
    var stickyThreshold;
    var fullHeaderHeight = header.offsetHeight;

    function refreshFullHeaderHeight() {
      if (!mobileSearchRow || !mobileSearchRow.hidden) {
        fullHeaderHeight = header.offsetHeight;
      }
    }

    if (window.ResizeObserver) {
      new ResizeObserver(refreshFullHeaderHeight).observe(header);
    }

    function getStickyThreshold() {
      var sentinel = document.querySelector('[data-hero-end]');
      // .bottom, not .top. Three markers can match this selector and
      // .bottom is the only reading correct for all of them:
      //   - sections/hero.liquid's is a zero-height bottom-anchored span,
      //     so .bottom === .top there and nothing changes.
      //   - snippets/blog-article-hero.liquid emits a top-anchored marker
      //     on BOTH of its article hero types, each sized to 100% of its
      //     own hero container. So .bottom is exactly that hero's real
      //     rendered height, at every viewport, never capped by one.
      // That last point is a CHANGE, and the contract this comment used to
      // state ("one viewport or the hero's height, whichever is shorter")
      // is now wrong. The old marker was one viewport tall under a
      // percentage max-height cap, which fell short of the hero whenever a
      // split/editorial hero's own content ran past one viewport — so this
      // threshold fired early, by an amount that varied with the device's
      // viewport height and the article's content length. Correcting it is
      // a deliberate, stakeholder-confirmed behaviour change (D74): on
      // split-hero articles the header now waits for the FULL hero height
      // to pass. Full-bleed articles are unaffected — their marker already
      // equalled their true hero height.
      // .top alone remains unusable on the split hero: it is always ~0
      // (that hero starts at the very top of the page, overlapped by the
      // header — see sections/article.liquid's own spacer-collapse
      // comment), so it read as an already-past threshold on load and
      // could flip the header into its sticky/box-shadow state before any
      // real scroll.
      if (sentinel) return sentinel.getBoundingClientRect().bottom + window.scrollY;
      return window.innerHeight;
    }

    function update() {
      ticking = false;
      if (stickyThreshold === undefined) stickyThreshold = getStickyThreshold();

      var scrollY = window.scrollY;
      var delta   = scrollY - lastScrollY;
      lastScrollY = scrollY;

      if (delta === 0) return; // deceleration stall — not a direction change

      var scrollingDown = delta > 0;

      // Spacer pages have no hero to protect: track the header at exactly
      // the page's own scroll rate instead of pinning it, so it leaves the
      // viewport at the same rate content arrives underneath it —
      // indistinguishable from a static element scrolling away. hide()/
      // show() below take over once it's fully clear of the viewport.
      if (hasSpacer && scrollY < fullHeaderHeight) {
        // Only reset the sticky/hidden trappings on the frame that actually
        // enters this zone from a different state — repeating that reset
        // (an attribute removal a CSS selector reacts to, plus three style
        // writes) every scroll frame forced extra style recalculation on
        // top of the transform change each frame, which read as jitter.
        if (isHidden || header.hasAttribute('data-sticky')) show(true);
        header.style.transitionDuration = '0s';
        header.style.transform = scrollY === 0 ? '' : 'translateY(-' + scrollY + 'px)';
        return;
      }

      // Overlay pages keep a header's-height dead zone at the top instead,
      // so the header doesn't hide while still mostly over the hero.
      if (!hasSpacer && scrollY <= fullHeaderHeight) {
        show(true);
        return;
      }

      if (scrollingDown && !isHidden) {
        hide();
      } else if (!scrollingDown && isHidden && scrollY >= stickyThreshold) {
        show(false);
      }
    }

    function hide() {
      isHidden = true;
      if (hasSpacer) header.style.transitionDuration = '0s';
      header.style.transform = 'translateY(calc(-100% - var(--spacing-12)))';
      header.removeAttribute('data-sticky');
      header.style.backgroundColor = '';
      header.style.color = '';
      if (mobileSearchRow) mobileSearchRow.hidden = true;
    }

    function show(atTop) {
      isHidden = false;
      header.style.transitionDuration = '';
      header.style.transform = '';
      if (atTop) {
        header.removeAttribute('data-sticky');
        header.style.backgroundColor = '';
        header.style.color = '';
        if (mobileSearchRow) mobileSearchRow.hidden = false;
        refreshFullHeaderHeight();
      } else {
        header.setAttribute('data-sticky', '');
        header.style.backgroundColor = 'var(--color-surface-primary)';
        header.style.color = 'var(--color-primary)';
        if (mobileSearchRow) mobileSearchRow.hidden = true;
      }
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      stickyThreshold = undefined;
      refreshFullHeaderHeight();
    }, { passive: true });

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', update, { passive: true });
    }

    /* Apply correct state on load — handles mid-page refresh where the browser
       restores scroll position before the first scroll event fires */
    requestAnimationFrame(function() {
      if (stickyThreshold === undefined) stickyThreshold = getStickyThreshold();
      lastScrollY = window.scrollY;
      if (lastScrollY >= stickyThreshold) {
        show(false);
      } else if (hasSpacer && lastScrollY > 0 && lastScrollY < fullHeaderHeight) {
        show(true);
        header.style.transitionDuration = '0s';
        header.style.transform = 'translateY(-' + lastScrollY + 'px)';
      } else if (lastScrollY > fullHeaderHeight) {
        header.style.transitionDuration = '0s';
        hide();
      }
    });
  })();

  /* Desktop mega-menu controller moved to mega-menu.liquid; mobile drawer
     drill controller moved to menu-drawer.liquid (D27 — each snippet owns
     its own javascript block). Both still toggle the shared
     [data-header][data-mega-open] attribute contract — see the comment
     in each file before renaming it. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function getBreakpointMd() {
    return getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md').trim();
  }

  // Mobile scroll-in: swap when the top card's top, or the bottom card's
  // bottom, hits its viewport edge -- a 0-height IO line per edge fires exactly there, unlike scroll/rAF on iOS.
  (function () {
    function initHero(hero) {
      var primary = hero.querySelector('[data-panel="primary"]');
      var secondary = hero.querySelector('[data-panel="secondary"]');
      if (!primary || !secondary) return;

      primary.classList.add('in-view');

      function setReveal(revealBelow) {
        primary.classList.toggle('in-view', !revealBelow);
        secondary.classList.toggle('in-view', revealBelow);
      }

      var topEdge = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setReveal(true);
        });
      }, { threshold: 0, rootMargin: '0px 0px -100% 0px' });
      topEdge.observe(primary);

      var bottomEdge = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setReveal(false);
        });
      }, { threshold: 0, rootMargin: '-100% 0px 0px 0px' });
      bottomEdge.observe(secondary);
    }

    function init() {
      document.querySelectorAll('.hero-double').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column-promo-banner"] && !Shopify.designMode) return;
  try {
    
  /* Multi Column Promo Bar — rotation below md, static row from md, and expiry.
     Rotation timing is identical to the Promo Banner: 3s hold, 0.3s fade out,
     next message fades in 0.3s later (3600ms cycle). All visual state is CSS;
     this file only writes data-promo-state and the hidden attribute. */
  ;(function () {
    var HOLD_MS = 3000;
    var FADE_MS = 300;
    var CYCLE_MS = HOLD_MS + FADE_MS + FADE_MS;

    /* setTimeout overflows above ~24.8 days and would fire immediately, so a
       further-off expiry is just checked on the next page load instead. */
    var MAX_TIMEOUT_MS = 2147483647;

    /* Must match the md breakpoint in the {% stylesheet %} above. */
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var controllers = [];

    function isDesktop() {
      return !!(desktop && desktop.matches);
    }

    /* Same parsing as the Countdown Banner: with no offset given, the store's
       UTC offset (rendered by Liquid) is appended. */
    function parseEnd(root) {
      var raw = (root.getAttribute('data-promo-bar-end') || '').trim().replace(' ', 'T');
      if (!raw) return null;

      var offset = root.getAttribute('data-promo-bar-offset') || '+00:00';

      if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(raw)) {
        if (/T\d{2}:\d{2}$/.test(raw)) raw += ':00';
        raw += offset;
      }

      var time = new Date(raw).getTime();

      if (isNaN(time)) {
        console.warn('Multi Column Promo Bar: could not read end date', root.getAttribute('data-promo-bar-end'));
        return null;
      }

      return time;
    }

    function destroyAll() {
      controllers.forEach(function (controller) {
        controller.destroy();
      });
      controllers = [];
    }

    function initBars() {
      destroyAll();

      var inEditor = window.Shopify && window.Shopify.designMode;

      document.querySelectorAll('[data-promo-bar]').forEach(function (root) {
        var messages = Array.prototype.slice.call(root.querySelectorAll('[data-promo-bar-message]'));
        var intervalId = null;
        var expiryId = null;

        /* Expiry — handled first so a single-message bar still hides on time.
           Never hidden in the theme editor, so the merchant can still edit it. */
        var end = parseEnd(root);

        if (end !== null && !inEditor) {
          var remaining = end - Date.now();

          if (remaining <= 0) {
            root.hidden = true;
            return;
          }

          if (remaining < MAX_TIMEOUT_MS) {
            expiryId = window.setTimeout(function () {
              stop();
              root.hidden = true;
            }, remaining);
          }
        }

        /* Seed from the DOM (see the Promo Banner for why), then make sure exactly
           one message is 'current' — after a desktop → mobile resize several
           could otherwise be left in mixed states. */
        var index = messages.findIndex(function (message) {
          return message.getAttribute('data-promo-state') === 'current';
        });

        if (index < 0) index = 0;

        function normalise() {
          messages.forEach(function (message, i) {
            message.setAttribute('data-promo-state', i === index ? 'current' : 'hidden');
          });
        }

        function advance() {
          var current = messages[index];

          index = (index + 1) % messages.length;

          var next = messages[index];

          current.setAttribute('data-promo-state', 'outgoing');

          function handOff() {
            if (current.getAttribute('data-promo-state') === 'outgoing') {
              current.setAttribute('data-promo-state', 'hidden');
            }
            next.setAttribute('data-promo-state', 'current');
          }

          if (reducedMotion && reducedMotion.matches) {
            handOff();
          } else {
            window.setTimeout(handOff, FADE_MS);
          }
        }

        function stop() {
          if (intervalId) {
            window.clearInterval(intervalId);
            intervalId = null;
          }
        }

        /* Only rotates below md, with more than one message, while visible. */
        function start() {
          stop();
          if (messages.length <= 1 || isDesktop() || root.hidden) return;
          intervalId = window.setInterval(advance, CYCLE_MS);
        }

        /* Pause on hover AND on keyboard focus (partial WCAG 2.2.2 mitigation).
           Now that messages can be links, focus matters: without the pause the
           focused link would rotate away and become hidden, dropping the
           keyboard user's focus. Listeners are bound once per element but always
           call the CURRENT controller, so they keep working after a theme-editor
           re-init. */
        root.__promoBarCtrl = { start: start, stop: stop };

        if (!root.__promoBarBound) {
          root.__promoBarBound = true;

          root.addEventListener('mouseenter', function () {
            if (root.__promoBarCtrl) root.__promoBarCtrl.stop();
          });
          root.addEventListener('mouseleave', function () {
            /* Don't resume while a link inside still has keyboard focus. */
            if (root.__promoBarCtrl && !root.contains(document.activeElement)) {
              root.__promoBarCtrl.start();
            }
          });
          root.addEventListener('focusin', function () {
            if (root.__promoBarCtrl) root.__promoBarCtrl.stop();
          });
          root.addEventListener('focusout', function (event) {
            /* Only resume once focus has left the bar entirely. */
            if (root.__promoBarCtrl && !root.contains(event.relatedTarget)) {
              root.__promoBarCtrl.start();
            }
          });
        }

        normalise();
        start();

        controllers.push({
          destroy: function () {
            stop();
            if (expiryId) window.clearTimeout(expiryId);
          },
          onBreakpointChange: function () {
            if (isDesktop()) {
              stop();
            } else {
              normalise();
              start();
            }
          }
        });
      });
    }

    if (desktop) {
      var handleBreakpoint = function () {
        controllers.forEach(function (controller) {
          controller.onBreakpointChange();
        });
      };

      if (desktop.addEventListener) {
        desktop.addEventListener('change', handleBreakpoint);
      } else if (desktop.addListener) {
        desktop.addListener(handleBreakpoint); /* older Safari */
      }
    }

    initBars();

    /* Theme editor swaps the section's DOM on edit — rebuild everything. */
    document.addEventListener('shopify:section:load', initBars);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  function revealPasswordGate(smooth) {
    var gate = document.getElementById('password-gate');
    if (!gate) return;
    gate.hidden = false;
    gate.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    var input = document.getElementById('password-input');
    if (input) input.focus();
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="#password-gate"]');
    if (!trigger) return;
    event.preventDefault();
    revealPasswordGate(true);
  });
  if (window.location.hash === '#password-gate') {
    revealPasswordGate(true);
  }
  // A wrong password reloads the page fresh at scroll 0 -- the browser has no
  // reason to land anywhere else. data-scroll-on-load (set server-side above,
  // only when form.errors forced this section open) jumps straight to it
  // instantly on load, no animation, since this is a page arriving already
  // in that state rather than a user-triggered reveal.
  if (document.getElementById('password-gate') && document.getElementById('password-gate').hasAttribute('data-scroll-on-load')) {
    revealPasswordGate(false);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    if (!window.__whittardSwymBisBridgeReady) {
      window.__whittardSwymBisBridgeReady = true;
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function (swat) {
        window.__whittardSwymBisInstance = swat;
        document.dispatchEvent(new CustomEvent('whittard:swym:ready'));
      });

      // Fallback for themes where Swym initialised before this section script.
      if (window._swat && typeof window._swat.subscribeForProductAlert === 'function') {
        window.__whittardSwymBisInstance = window._swat;
      }
    }

    // Custom-eased smooth scroll — native `behavior: 'smooth'` runs faster in Safari
    // than Chrome/Firefox with no way to tune it, so we animate manually instead
    function smoothScrollTo(targetY, duration) {
      duration = duration || 600;
      var startY = window.scrollY || window.pageYOffset || 0;
      var distance = targetY - startY;
      var startTime = null;

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, startY + distance * easeInOutQuad(progress));
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      var form = section.querySelector('[data-product-form]');
      var dataEl = section.querySelector('[data-variant-data]');
      var sellingPlanDataEl = section.querySelector('[data-selling-plan-data]');
      var moreInfoLinks = section.querySelectorAll('[data-more-info-scroll]');
      var aboutProductWrapper = section.querySelector('[data-about-product-target]');
      var aboutProductCard = section.querySelector('[data-about-product-card]');
      var reviewLinks = section.querySelectorAll('[data-reviews-scroll]');
      var reviewsTarget = section.querySelector('#reviews');
      if (!form || !dataEl) return;

      // A bundle (fixed or custom) always ships as one gift-wrapped unit regardless
      // of any one line's own stock nuances, so the warehouse-only rule never
      // applies to it - only Shopify's own blended availability decides (see
      // warehouse-available.liquid's matching bundle exception).
      var IS_BUNDLE = section.getAttribute('data-product-is-bundle') === 'true';

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var sellingPlans = [];
      if (sellingPlanDataEl) {
        try {
          sellingPlans = JSON.parse(sellingPlanDataEl.textContent || '[]');
        } catch (e) {
          sellingPlans = [];
        }
      }

      var picker = form.querySelector('[data-variant-picker]');
      var idInput = form.querySelector('[data-variant-id]');
      // Fallback id for app widgets (ReCharge) that infer the product form from [name="id"]; must never be blank
      var subscriptionFallbackId = idInput ? idInput.getAttribute('value') : '';
      var quantityInput = form.querySelector('input[name="quantity"]');
      var priceCurrent = section.querySelector('[data-price-current]');
      var priceCompare = section.querySelector('[data-price-compare]');
      var addToCartWrap = section.querySelector('[data-add-to-cart]');
      var notifyCtaWrap = form.querySelector('[data-notify-me]');
      var cta = addToCartWrap ? addToCartWrap.querySelector('button[type="submit"]') : form.querySelector('button[type="submit"]');
      var availability = section.querySelector('[data-availability-message]'); // removed from markup (not in Figma); null-safe below
      var introEl = section.querySelector('[data-variant-intro]');
      var specsBlocks = section.querySelectorAll('[data-specs-variant], [data-specs-fallback]');
      // Reached from a block because accordion-item is shared and takes no hook of its own
      var specsAccordion = specsBlocks.length ? specsBlocks[0].closest('[data-accordion]') : null;
      var buyBoxNoteWrap = form.querySelector('[data-buy-box-note-wrap]');
      var buyBoxNote = form.querySelector('[data-buy-box-note]');
      var buyBoxNoteIcon = form.querySelector('[data-buy-box-note-icon]');
      var buyBoxSignpostRow = form.querySelector('[data-buy-box-signpost-row]');
      // TASK-54807: the Find in Store trigger only exists in the DOM when show_find_in_store
      // was true at render time (Liquid-gated, not JS-toggled) — its mere presence is the signal
      // this row must stay visible even when the note itself has no message.
      var hasFindInStoreTrigger = Boolean(form.querySelector('[data-find-in-store-trigger-wrap]'));
      var buyBoxAppBlocks = form.querySelector('[data-buy-box-app-blocks]');
      var stickyImage = section.querySelector('[data-sticky-atb-image]');
      var stickyPriceCurrent = section.querySelector('[data-sticky-atb-price-current]');
      var stickyOptionButtons = section.querySelectorAll('[data-sticky-option-jump]');
      var stickyOptionValues = section.querySelectorAll('[data-sticky-option-value]');
      var stickySubscriptionSummary = section.querySelector('[data-sticky-subscription-summary]');
      var stickySubscriptionValue = section.querySelector('[data-sticky-subscription-value]');
      var stickySubscriptionJump = section.querySelector('[data-sticky-subscription-jump]');
      var stickySubmitButtons = section.querySelectorAll('[data-sticky-atb-submit]');
      var stickySubmitWraps = section.querySelectorAll('[data-sticky-atb-submit-wrap]');
      var stickyNotifyWraps = section.querySelectorAll('[data-sticky-notify-wrap]');
      var notifyOpenButtons = section.querySelectorAll('[data-notify-me-open]:not([data-oos-notify])');
      var mainActionArea = section.querySelector('[data-product-primary-actions]');
      var header = document.getElementById('site-header');
      var labelAdd = form.getAttribute('data-cta-add');
      var labelChoose = form.getAttribute('data-cta-choose');
      var labelChooseSize = form.getAttribute('data-cta-choose-size') || form.getAttribute('data-cta-choose');
      var labelNotify = form.getAttribute('data-cta-notify');
      var labelUnavailable = form.getAttribute('data-cta-unavailable');
      var notifyFeatureEnabled = form.getAttribute('data-notify-enabled') !== 'false';
      var optionGroups = picker ? picker.querySelectorAll('[data-option-group]') : [];
      var sizeAxisGroup = picker ? picker.querySelector('[data-size-axis]') : null;
      var oosNotifyButtons = picker ? picker.querySelectorAll('[data-oos-notify]') : [];
      var notifyDrawerId = form.getAttribute('data-notify-drawer-id');
      var emptyCaddyId = (form.getAttribute('data-empty-caddy-id') || '').trim();
      var notifyDrawer = notifyDrawerId ? document.getElementById(notifyDrawerId) : null;
      var notifyForm = notifyDrawer ? notifyDrawer.querySelector('[data-notify-me-form]') : null;
      var notifyFields = notifyDrawer ? notifyDrawer.querySelector('[data-notify-form-fields]') : null;
      var notifyDescription = notifyDrawer ? notifyDrawer.querySelector('[data-notify-description]') : null;
      var notifySuccess = notifyDrawer ? notifyDrawer.querySelector('[data-notify-success]') : null;
      var notifyStatus = notifyDrawer ? notifyDrawer.querySelector('[data-notify-status]') : null;
      var notifyError = notifyDrawer ? notifyDrawer.querySelector('[data-notify-error]') : null;
      var notifyEmail = notifyDrawer ? notifyDrawer.querySelector('[data-notify-email]') : null;
      var notifyMarketing = notifyDrawer ? notifyDrawer.querySelector('[data-notify-marketing]') : null;
      var notifySubmit = notifyDrawer ? notifyDrawer.querySelector('[data-notify-submit]') : null;
      var notifySummary = notifyDrawer ? notifyDrawer.querySelector('[data-notify-summary]') : null;
      var notifySummaryImages = notifyDrawer ? notifyDrawer.querySelectorAll('[data-notify-product-image]') : [];
      var notifyPrimaryImage = notifyDrawer ? notifyDrawer.querySelector('[data-notify-primary-image]') : null;
      var notifySummaryTitle = notifyDrawer ? notifyDrawer.querySelector('[data-notify-product-title]') : null;
      var notifySummaryVariant = notifyDrawer ? notifyDrawer.querySelector('[data-notify-variant-summary]') : null;
      var notifySummaryFormat = notifyDrawer ? notifyDrawer.querySelector('[data-notify-variant-format]') : null;
      var notifySummarySeparator = notifyDrawer ? notifyDrawer.querySelector('[data-notify-variant-separator]') : null;
      var notifySummarySize = notifyDrawer ? notifyDrawer.querySelector('[data-notify-variant-size]') : null;
      var notifySummaryPrice = notifyDrawer ? notifyDrawer.querySelector('[data-notify-price]') : null;
      var findStoreTriggerWrap = form.querySelector('[data-find-in-store-trigger-wrap]');
      var findStoreOpenButtons = section.querySelectorAll('[data-find-in-store-open]');
      var findStoreTriggerLabels = section.querySelectorAll('[data-find-store-trigger-label]');
      var findStoreDrawerId = form.getAttribute('data-find-in-store-drawer-id');
      var findStoreDrawer = findStoreDrawerId ? document.getElementById(findStoreDrawerId) : null;
      var findStoreForm = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-form]') : null;
      var findStoreInput = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-input]') : null;
      var findStoreResults = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-results]') : null;
      var findStoreResultsList = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-results-list]') : null;
      var findStoreNote = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-note]') : null;
      var findStoreMedia = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-media]') : null;
      var findStoreEmpty = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-empty]') : null;
      var findStoreError = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-error]') : null;
      var findStoreStatus = findStoreDrawer ? findStoreDrawer.querySelector('[data-find-store-status]') : null;
      var findStoreStockIconInTemplate = section.querySelector('[data-find-store-stock-icon-in]');
      var findStoreStockIconOutTemplate = section.querySelector('[data-find-store-stock-icon-out]');
      var buyBoxHelperText = decodeHtmlEntities(section.getAttribute('data-buy-box-helper') || '');
      var lowStockTemplate = decodeHtmlEntities(section.getAttribute('data-buy-box-low-stock-template') || '');
      var lowStockThreshold = parseInt(section.getAttribute('data-buy-box-low-stock-threshold') || '0', 10);
      var lastScrollY = window.scrollY || window.pageYOffset || 0;
      var mobileScrollDirection = 'down';
      var notifySubmitting = false;
      var findStoreSearching = false;
      var findStoreAbortController = null;
      var findStoreDebounceTimer = null;
      var currentVariant = null;
      var currentSelectionState = [];

      var FIND_STORE_STORAGE_KEY = 'whittard:findStore:selectedLocation';

      function readStoredFindStoreSelection() {
        try {
          var raw = window.localStorage.getItem(FIND_STORE_STORAGE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      }

      function writeStoredFindStoreSelection(selection) {
        try {
          window.localStorage.setItem(FIND_STORE_STORAGE_KEY, JSON.stringify(selection));
        } catch (error) {
        }
      }

      var storedFindStoreSelection = readStoredFindStoreSelection();

      function currentSelection() {
        var selection = [];
        if (!picker) return selection;
        picker.querySelectorAll('input[data-option-position]:checked').forEach(function (input) {
          var index = parseInt(input.getAttribute('data-option-position'), 10) - 1;
          selection[index] = input.value;
        });
        return selection;
      }

      function sizeAxisSelected() {
        if (!sizeAxisGroup) return true;
        return Boolean(sizeAxisGroup.querySelector('input[data-option-position]:checked'));
      }

      function matchVariant(selection) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          if (variant.options.length !== selection.length) continue;
          var matches = true;
          for (var j = 0; j < selection.length; j++) {
            if (variant.options[j] !== selection[j]) {
              matches = false;
              break;
            }
          }
          if (matches) return variant;
        }
        return null;
      }

      function setHidden(element, hidden) {
        if (!element) return;
        element.classList.toggle('hidden', hidden);
        if (hidden) {
          element.setAttribute('aria-hidden', 'true');
        } else {
          element.removeAttribute('aria-hidden');
        }
      }

      function setElementHidden(element, hidden) {
        if (!element) return;
        element.hidden = hidden;
      }

      function decodeHtmlEntities(value) {
        if (!value || value.indexOf('&') === -1) return value || '';
        var parser = document.createElement('textarea');
        parser.innerHTML = value;
        return parser.value;
      }

      function setBuyBoxNote(message, tone) {
        if (!buyBoxNoteWrap || !buyBoxNote) return;

        var visible = Boolean(message);
        buyBoxNote.textContent = message || '';
        buyBoxNoteWrap.classList.toggle('hidden', !visible);
        buyBoxNoteWrap.classList.toggle('flex', visible);

        if (buyBoxSignpostRow) {
          // TASK-54807: the row must stay visible whenever the note has content OR the
          // trigger is present, otherwise an empty-but-flex row still eats the parent's
          // gap-32 on non-GB markets with no low-stock/helper-text message.
          var rowVisible = visible || hasFindInStoreTrigger;
          buyBoxSignpostRow.classList.toggle('hidden', !rowVisible);
          buyBoxSignpostRow.classList.toggle('flex', rowVisible);
        }

        if (buyBoxNoteIcon) {
          buyBoxNoteIcon.classList.toggle('text-brand-primary-blue', tone === 'accent');
          buyBoxNoteIcon.classList.toggle('text-secondary', tone !== 'accent');
        }

        buyBoxNote.classList.toggle('text-brand-primary-blue', tone === 'accent');
        buyBoxNote.classList.toggle('text-secondary', tone !== 'accent');
      }

      /* Warehouse-only deliverable stock, from the custom.warehouse_stock variant
         metafield carried on data-variant-data. Shopify's own available /
         inventory_quantity blend Warehouse and retail-store stock, and Warehouse is
         the only shipping origin, so they cannot tell a deliverable variant from a
         shop-floor-only one.
         null or undefined means the variant has not been backfilled yet: that is
         UNKNOWN, and every caller falls back to the pre-fix blended signal. Only an
         explicit number is authoritative, including an explicit zero. */
      function warehouseQty(variant) {
        if (!variant) return null;
        var raw = variant.warehouse_stock;
        if (raw === null || raw === undefined || raw === '') return null;
        var n = Number(raw);
        return Number.isFinite(n) ? n : null;
      }

      /* Per the client's confirmed decision: warehouse stock of exactly zero
         ALWAYS means unavailable/Notify, regardless of retail-store stock. An
         unknown (not yet backfilled) figure falls back to the blended signal -
         there is no better answer available. Warehouse stock never LOOSENS
         availability either: a known-positive figure only confirms the blend,
         it does not override a blend that is independently false (market
         exclusion, scheduled release, sales-channel removal all say nothing
         about warehouse stock and must still apply). Correct formula:
         blended AND (unknown OR warehouse > 0). Warehouse stock still only
         ever tightens the quantity cap (product-quantity.js) when it's a
         positive number below the blended figure; it never loosens that
         either. */
      function warehouseAvailable(variant) {
        var blended = Boolean(variant && variant.available);
        if (IS_BUNDLE) return blended;
        var n = warehouseQty(variant);
        if (n === null) return blended;
        return blended && n > 0;
      }

      function lowStockMessage(variant) {
        if (!variant || !warehouseAvailable(variant)) return '';
        if (!variant.inventory_management) return '';
        if (variant.inventory_policy === 'continue') return '';

        var whQty = warehouseQty(variant);
        var quantity = whQty === null ? Number(variant.inventory_quantity) : whQty;
        if (!Number.isFinite(quantity) || quantity <= 0) return '';
        if (!lowStockThreshold || quantity > lowStockThreshold) return '';
        if (!lowStockTemplate) return '';

        return lowStockTemplate.replace('[[count]]', String(quantity));
      }

      function syncBuyBoxNote(variant) {
        var message = lowStockMessage(variant);
        var tone = 'accent';

        if (!message && buyBoxHelperText) {
          message = buyBoxHelperText;
          tone = 'secondary';
        }

        setBuyBoxNote(message, tone);
      }

      function notifyVariantSummary(variant) {
        if (!variant) {
          return {
            format: '',
            size: '',
            visible: false
          };
        }
        var format = String(variant.format || '').trim();
        var size = String(variant.size || '').trim();
        var servings = String(variant.servings_label || '').trim();
        var sizeWithServings = size;
        if (servings) {
          sizeWithServings += (sizeWithServings ? ' ' : '') + '(' + servings + ')';
        }
        return {
          format: format,
          size: sizeWithServings,
          visible: Boolean(format || sizeWithServings)
        };
      }

      function hasFindStoreAvailability(variant) {
        return Boolean(
          variant &&
          Array.isArray(variant.store_availabilities) &&
          variant.store_availabilities.length
        );
      }

      function syncStickyCta() {
        if (!cta) return;
        stickySubmitButtons.forEach(function (button) {
          button.textContent = cta.textContent;
          button.disabled = cta.disabled;
          if (cta.disabled) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }
        });
      }

      function syncActionMode(mode) {
        var showNotify = mode === 'notify' && notifyFeatureEnabled;
        setHidden(addToCartWrap, showNotify);
        setHidden(notifyCtaWrap, !showNotify);

        stickySubmitWraps.forEach(function (wrap) {
          setHidden(wrap, showNotify);
        });
        stickyNotifyWraps.forEach(function (wrap) {
          setHidden(wrap, !showNotify);
        });
      }

      function syncStickyImage() {
        if (!stickyImage) return;

        var imageSrc = stickyImage.getAttribute('data-default-src');

        if (!imageSrc) return;

        stickyImage.querySelectorAll('source').forEach(function (source) {
          source.removeAttribute('srcset');
          source.removeAttribute('data-srcset');
        });

        stickyImage.querySelectorAll('img').forEach(function (image) {
          image.src = imageSrc;
          image.srcset = imageSrc;
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
        });
      }

      function syncStickySummary(selection, variant) {
        stickyOptionValues.forEach(function (label) {
          var index = parseInt(label.getAttribute('data-option-position'), 10) - 1;
          if (selection[index] != null) {
            label.textContent = selection[index];
            var button = label.closest('[data-sticky-option-jump]');
            if (button) {
              var optionLabel = button.querySelector('[data-sticky-option-label]');
              var optionName = optionLabel ? optionLabel.textContent.trim() : '';
              button.setAttribute('aria-label', optionName + ': ' + selection[index]);
            }
          } else {
            label.textContent = 'Choose';
          }
        });

        if (stickyPriceCurrent && priceCurrent) {
          stickyPriceCurrent.textContent = priceCurrent.textContent;
          stickyPriceCurrent.classList.toggle('text-semantic-red', priceCurrent.classList.contains('text-semantic-red'));
        }

        syncStickyImage();
        syncStickyCta();
      }

      function getSelectedSellingPlanId() {
        var checkedInput = form.querySelector(
          'input[name="selling_plan"]:checked, input[name*="selling_plan"]:checked'
        );

        if (checkedInput && checkedInput.value) {
          return checkedInput.value;
        }

        var select = form.querySelector(
          'select[name="selling_plan"], select[name*="selling_plan"]'
        );

        if (select && select.value) {
          return select.value;
        }

        var hiddenInput = form.querySelector(
          'input[type="hidden"][name="selling_plan"], input[type="hidden"][name*="selling_plan"]'
        );

        if (hiddenInput && hiddenInput.value) {
          return hiddenInput.value;
        }

        return '';
      }

      function formatSellingPlanLabel(label) {
        var text = String(label || '')
          .replace(/\s+subscription$/i, '')
          .trim();
        text = text.replace(/^(\d+)\s+week$/i, function (match, count) {
          return Number(count) === 1 ? count + ' week' : count + ' weeks';
        });
        return text;
      }

      function sellingPlanLabel(planId) {
        if (!planId) return '';
        var plan = sellingPlans.find(function (item) {
          return String(item.id) === String(planId);
        });
        return plan && plan.name ? formatSellingPlanLabel(plan.name) : '';
      }

      function syncStickySubscriptionSummary() {
        if (!stickySubscriptionSummary || !stickySubscriptionValue) return;
        var planId = getSelectedSellingPlanId();
        var frequency = sellingPlanLabel(planId);
        var visible = Boolean(planId && frequency);
        stickySubscriptionValue.textContent = frequency || '';
        stickySubscriptionSummary.classList.toggle('hidden', !visible);
        stickySubscriptionSummary.classList.toggle('flex', visible);
      }

      function syncStickySubscriptionSummarySoon() {
        syncStickySubscriptionSummary();
        window.requestAnimationFrame(function () {
          syncStickySubscriptionSummary();
        });
        window.setTimeout(syncStickySubscriptionSummary, 100);
      }

      function rechargeShadowHosts() {
        if (!buyBoxAppBlocks) return [];
        return Array.prototype.slice.call(
          buyBoxAppBlocks.querySelectorAll('recharge-subscription-widget, rc-selling-plans')
        ).filter(function (host) {
          return Boolean(host.shadowRoot);
        });
      }

      function bindRechargeStickySummaryListeners() {
        rechargeShadowHosts().forEach(function (host) {
          if (host.__stickySubscriptionBound) return;
          host.__stickySubscriptionBound = true;
          host.shadowRoot.addEventListener('change', function (event) {
            if (
              event.target.matches(
                'select[name="rc_plan"], select[name*="rc_plan"], select[name="selling_plan"], select[name*="selling_plan"]'
              )
            ) {
              syncStickySubscriptionSummarySoon();
            }
          });
          host.shadowRoot.addEventListener('click', function () {
            syncStickySubscriptionSummarySoon();
          });
        });
      }

      function subscriptionWidgetTarget() {
        if (!buyBoxAppBlocks) return null;
        return (
          buyBoxAppBlocks.querySelector('recharge-subscription-widget') ||
          buyBoxAppBlocks.querySelector('rc-selling-plans') ||
          buyBoxAppBlocks
        );
      }

      function scrollToSubscriptionWidget() {
        var target = subscriptionWidgetTarget();
        if (!target) return;
        var headerOffset = header ? header.offsetHeight : 0;
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      }

      function syncNotifySummary(selection, variant) {
        if (!notifyDrawer) return;

        if (notifySummaryTitle) {
          notifySummaryTitle.textContent = section.getAttribute('data-product-title') || notifySummaryTitle.textContent;
        }

        notifySummaryImages.forEach(function (imageWrap, index) {
          if (!imageWrap) return;
          var defaultImageSrc = imageWrap.getAttribute('data-default-src');
          var imageSrc = index === 0 && variant && variant.image
            ? variant.image
            : defaultImageSrc;
          if (!imageSrc) return;
          imageWrap.querySelectorAll('source').forEach(function (source) {
            source.removeAttribute('srcset');
            source.removeAttribute('data-srcset');
          });
          imageWrap.querySelectorAll('img').forEach(function (image) {
            image.src = imageSrc;
            image.srcset = imageSrc;
            image.removeAttribute('data-src');
            image.removeAttribute('data-srcset');
          });
        });

        if (notifySummaryPrice && variant) {
          notifySummaryPrice.textContent = variant.price;
        }

        if (notifySummaryVariant) {
          var summary = notifyVariantSummary(variant);
          var showSeparator = Boolean(summary.format && summary.size);
          if (notifySummaryFormat) {
            notifySummaryFormat.textContent = summary.format;
            notifySummaryFormat.classList.toggle('hidden', !summary.format);
          }
          if (notifySummarySeparator) {
            notifySummarySeparator.classList.toggle('hidden', !showSeparator);
          }
          if (notifySummarySize) {
            notifySummarySize.textContent = summary.size;
            notifySummarySize.classList.toggle('hidden', !summary.size);
          }
          notifySummaryVariant.classList.toggle('hidden', !summary.visible);
          if (notifySummary) {
            notifySummary.classList.toggle('hidden', !summary.visible);
          }
        }
      }

      function buildStoreAddress(location) {
        if (!location) return '';

        var lines = [];
        var lineOne = [location.address1, location.address2].filter(Boolean).join(', ');
        var lineTwo = [location.city, location.province, location.zip].filter(Boolean).join(', ');

        if (lineOne) lines.push(lineOne);
        if (lineTwo) lines.push(lineTwo);
        if (!lines.length && location.country) lines.push(location.country);

        return lines.join('\n');
      }

      // snippets/store-search-loqate.liquid's own doc notes its script bundle can load
      // after this section's — reading window.WhittardStoreSearch immediately and
      // giving up on a miss would misreport "not loaded yet" as "no postcode match"
      // (setFindStoreEmpty below treats both the same way). Waiting for the ready
      // event instead of failing fast keeps that distinction correct.
      function waitForStoreSearchHelpers(signal) {
        if (window.WhittardStoreSearch) return Promise.resolve(window.WhittardStoreSearch);

        return new Promise(function (resolve, reject) {
          function onReady() {
            document.removeEventListener('store-finder:helpers-ready', onReady);
            resolve(window.WhittardStoreSearch);
          }
          document.addEventListener('store-finder:helpers-ready', onReady);

          if (signal) {
            signal.addEventListener('abort', function () {
              document.removeEventListener('store-finder:helpers-ready', onReady);
              reject(new DOMException('Aborted', 'AbortError'));
            });
          }
        });
      }

      async function fetchLoqateCoordinates(query, signal) {
        if (!findStoreForm) return null;

        var loqateKey = findStoreForm.getAttribute('data-loqate-key');
        if (!loqateKey) return null;

        var helpers = await waitForStoreSearchHelpers(signal);

        var fallbackError = findStoreForm.getAttribute('data-error') || 'Unable to search';

        var country = findStoreForm.getAttribute('data-search-country') || 'GBR';

        var items = await helpers.loqateFindPlaceNames({
          key: loqateKey,
          query: query,
          matchType: findStoreForm.getAttribute('data-search-match-type') || 'Similar',
          country: country,
          signal: signal,
          fallbackError: fallbackError
        });

        // Drops the fuzzy near-misses Loqate returns for nonsense input, so "asdf"
        // no longer resolves to Ayside, Cumbria. Points of interest are KEPT here,
        // unlike on the Store Finder page: this match is only a geocoding origin,
        // and "Meadowhall" or "Gatwick" return a POI row and nothing else.
        var matches = helpers.relevantPlaceMatches(query, items, { includePointsOfInterest: true });
        var match = matches.length ? matches[0] : null;

        if (match) {
          var place = await helpers.loqateRetrieveCoordinates({
            key: loqateKey,
            id: match.id,
            signal: signal,
            fallbackError: fallbackError
          });
          if (place) return place;
        }

        // Place-name search misses ~12-15% of real UK postcodes and every
        // outward code on its own, so a valid postcode reported "no stores
        // found" here. Second tier resolves those directly to coordinates.
        if (typeof helpers.loqateGeocode !== 'function') return null;
        if (!helpers.isUkPostcodeQuery(query)) return null;

        return await helpers.loqateGeocode({
          key: loqateKey,
          query: query,
          country: country,
          signal: signal,
          fallbackError: fallbackError
        });
      }

      function setFindStoreIntroVisible(visible) {
        setElementHidden(findStoreNote, !visible);
        setElementHidden(findStoreMedia, !visible);
      }

      function clearFindStoreResults() {
        if (findStoreResultsList) {
          findStoreResultsList.innerHTML = '';
        }

        setElementHidden(findStoreResults, true);
        setFindStoreIntroVisible(true);
      }

      function clearFindStoreFeedback() {
        if (findStoreEmpty) {
          findStoreEmpty.textContent = '';
          setElementHidden(findStoreEmpty, true);
        }

        if (findStoreError) {
          findStoreError.textContent = '';
          setElementHidden(findStoreError, true);
        }

        if (findStoreStatus) {
          findStoreStatus.textContent = '';
        }
      }

      function setFindStoreEmpty(message) {
        if (!findStoreEmpty) return;
        var text = decodeHtmlEntities(message || '');
        findStoreEmpty.textContent = text;
        setElementHidden(findStoreEmpty, !text);
      }

      function setFindStoreError(message) {
        if (!findStoreError) return;
        findStoreError.textContent = message || '';
        setElementHidden(findStoreError, !message);
      }

      function syncFindStoreTrigger(variant) {
        if (!findStoreTriggerWrap) return;

        var enabled = Boolean(
          variant &&
          findStoreForm &&
          findStoreForm.getAttribute('data-loqate-key')
        );

        findStoreOpenButtons.forEach(function (button) {
          button.disabled = !enabled;
          if (enabled) {
            button.removeAttribute('aria-disabled');
          } else {
            button.setAttribute('aria-disabled', 'true');
          }
        });
      }

      function syncFindStoreTriggerLabel(locationName) {
        var defaultLabel = decodeHtmlEntities(section.getAttribute('data-find-store-label-default') || '');
        var selectedLabelTemplate = decodeHtmlEntities(section.getAttribute('data-find-store-label-selected') || defaultLabel);
        var nextLabel = defaultLabel;

        if (locationName) {
          nextLabel = selectedLabelTemplate.replace('[[location]]', locationName);
        }

        findStoreOpenButtons.forEach(function (button) {
          button.setAttribute('aria-label', nextLabel);
        });

        findStoreTriggerLabels.forEach(function (label) {
          label.textContent = nextLabel;
          if (locationName) {
            label.setAttribute('title', nextLabel);
          } else {
            label.removeAttribute('title');
          }
        });
      }

      function clearBundledLineItems() {
        form.querySelectorAll('[data-bundled-line-item]').forEach(function (input) {
          input.remove();
        });
      }

      function restorePrimaryLineInputs() {
        if (idInput) idInput.disabled = false;
        if (quantityInput) quantityInput.disabled = false;
      }

      function appendBundledLineInput(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.setAttribute('data-bundled-line-item', '');
        form.appendChild(input);
      }

      function prepareCartSubmission() {
        clearBundledLineItems();
        restorePrimaryLineInputs();

        if (!currentVariant || currentVariant.non_core !== true || !emptyCaddyId) {
          return function cleanupPreparedSubmission() {
            clearBundledLineItems();
            restorePrimaryLineInputs();
          };
        }

        var primaryQuantity = quantityInput && quantityInput.value ? quantityInput.value : '1';

        if (idInput) idInput.disabled = true;
        if (quantityInput) quantityInput.disabled = true;

        appendBundledLineInput('items[0][id]', String(currentVariant.id));
        appendBundledLineInput('items[0][quantity]', String(primaryQuantity));
        appendBundledLineInput('items[1][id]', emptyCaddyId);
        appendBundledLineInput('items[1][quantity]', '1');

        return function cleanupPreparedSubmission() {
          clearBundledLineItems();
          restorePrimaryLineInputs();
        };
      }

      function sortedStoreAvailabilities(availabilities, origin) {
        var items = Array.isArray(availabilities) ? availabilities.slice() : [];

        var helpers = window.WhittardStoreSearch;
        if (!helpers) return items;
        var distanceBetween = helpers.distanceBetween;

        items.sort(function (first, second) {
          var firstLocation = first && first.location ? first.location : {};
          var secondLocation = second && second.location ? second.location : {};
          var firstDistance = distanceBetween(origin, {
            latitude: firstLocation.latitude == null ? null : Number(firstLocation.latitude),
            longitude: firstLocation.longitude == null ? null : Number(firstLocation.longitude)
          });
          var secondDistance = distanceBetween(origin, {
            latitude: secondLocation.latitude == null ? null : Number(secondLocation.latitude),
            longitude: secondLocation.longitude == null ? null : Number(secondLocation.longitude)
          });

          if (firstDistance !== secondDistance) return firstDistance - secondDistance;

          var firstName = firstLocation.name || '';
          var secondName = secondLocation.name || '';
          return firstName.localeCompare(secondName);
        });

        return items;
      }

      function createFindStoreItem(storeAvailability) {
        var location = storeAvailability.location || {};
        var button = document.createElement('button');
        var marker = document.createElement('span');
        var markerDot = document.createElement('span');
        var copy = document.createElement('span');
        var name = document.createElement('span');
        var address = document.createElement('span');
        var stock = document.createElement('span');
        var stockIcon = document.createElement('span');
        var stockLabel = document.createElement('span');
        var addressText = buildStoreAddress(location);
        var stockText = storeAvailability.available
          ? section.getAttribute('data-find-store-label-in')
          : section.getAttribute('data-find-store-label-out');
        var stockTemplate = storeAvailability.available
          ? findStoreStockIconInTemplate
          : findStoreStockIconOutTemplate;

        var locationId = location.id != null ? String(location.id) : '';
        var isStoredSelection = Boolean(
          storedFindStoreSelection &&
          storedFindStoreSelection.id &&
          locationId &&
          String(storedFindStoreSelection.id) === locationId
        );

        button.type = 'button';
        button.setAttribute('data-find-store-item', '');
        button.setAttribute('data-find-store-item-id', locationId);
        button.setAttribute('data-selected', isStoredSelection ? 'true' : 'false');
        button.setAttribute('aria-pressed', isStoredSelection ? 'true' : 'false');

        marker.setAttribute('data-find-store-marker', '');
        markerDot.setAttribute('data-find-store-marker-dot', '');
        marker.appendChild(markerDot);

        copy.setAttribute('data-find-store-copy', '');
        name.setAttribute('data-find-store-name', '');
        name.textContent = location.name || '';

        address.setAttribute('data-find-store-address', '');
        address.textContent = addressText;

        stock.setAttribute('data-find-store-stock', storeAvailability.available ? 'in' : 'out');
        stockIcon.setAttribute('data-find-store-stock-icon', '');
        if (stockTemplate && stockTemplate.content) {
          stockIcon.appendChild(stockTemplate.content.cloneNode(true));
        }

        stockLabel.textContent = stockText;
        stock.appendChild(stockIcon);
        stock.appendChild(stockLabel);

        copy.appendChild(name);
        copy.appendChild(address);
        button.appendChild(marker);
        button.appendChild(copy);
        button.appendChild(stock);
        button.setAttribute(
          'aria-label',
          [location.name, addressText, stockText].filter(Boolean).join(', ')
        );

        return button;
      }

      function renderFindStoreResults(storeAvailabilities) {
        if (!findStoreResultsList) return;

        clearFindStoreResults();
        clearFindStoreFeedback();

        if (!storeAvailabilities.length) {
          setFindStoreIntroVisible(true);
          setFindStoreEmpty(findStoreForm ? findStoreForm.getAttribute('data-no-availability') : '');
          return;
        }

        storeAvailabilities.forEach(function (storeAvailability) {
          findStoreResultsList.appendChild(createFindStoreItem(storeAvailability));
        });

        setFindStoreIntroVisible(false);
        setElementHidden(findStoreResults, false);
      }

      function resetFindStoreDrawer() {
        clearTimeout(findStoreDebounceTimer);

        if (findStoreAbortController) {
          findStoreAbortController.abort();
          findStoreAbortController = null;
        }

        findStoreSearching = false;

        if (findStoreForm) {
          findStoreForm.reset();
        }

        // form.reset() clears the value but fires no input event, so the floating
        // label (input.liquid) is left floated above what is now an empty field.
        if (findStoreInput) {
          var findStoreFloatField = findStoreInput.closest('[data-float-field]');
          if (findStoreFloatField) findStoreFloatField.classList.remove('is-floated');
        }

        clearFindStoreResults();
        clearFindStoreFeedback();

        if (currentVariant && !hasFindStoreAvailability(currentVariant)) {
          setFindStoreEmpty(findStoreForm ? findStoreForm.getAttribute('data-no-availability') : '');
        }
      }

      function mainActionVisible() {
        if (!mainActionArea) return false;
        var rect = mainActionArea.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      }

      // The sticky buy-panel offset (--pdp-buy-panel-sticky-top) is computed by the
      // shared BuyPanelSticky module in assets/product-sticky-atb.js, not here — it is
      // shared so that form-less templates, which never enter this controller, reach it
      // too (see that file's own docblock). This
      // section still calls window.BuyPanelSticky.refresh(section) below on every
      // selection change, since a variant swap can change buyPanelContent's height
      // ahead of the module's own ResizeObserver firing.

      function setNotifyError(message) {
        if (!notifyError) return;
        notifyError.textContent = message || '';
        notifyError.classList.toggle('hidden', !message);
      }

      function syncNotifySubmitState() {
        if (!notifySubmit) return;

        if (notifySubmit.hasAttribute('data-drawer-close')) {
          notifySubmit.disabled = false;
          notifySubmit.removeAttribute('aria-disabled');
          return;
        }

        if (!notifyEmail) {
          notifySubmit.disabled = true;
          notifySubmit.setAttribute('aria-disabled', 'true');
          return;
        }

        var canSubmit = Boolean(
          !notifySubmitting &&
          currentVariant &&
          warehouseAvailable(currentVariant) === false &&
          notifyEmail.value.trim() &&
          notifyEmail.checkValidity()
        );

        notifySubmit.disabled = !canSubmit;
        notifySubmit.textContent = notifySubmitting
          ? notifySubmit.getAttribute('data-loading-label')
          : notifySubmit.getAttribute('data-submit-label');

        if (notifySubmit.disabled) {
          notifySubmit.setAttribute('aria-disabled', 'true');
        } else {
          notifySubmit.removeAttribute('aria-disabled');
        }
      }

      function resetNotifyDrawer() {
        if (!notifyForm) return;

        notifyForm.reset();
        notifySubmitting = false;

        if (notifyFields) notifyFields.classList.remove('hidden');
        if (notifyDescription) notifyDescription.classList.remove('hidden');
        if (notifySuccess) {
          notifySuccess.classList.add('hidden');
        }

        if (notifyStatus) notifyStatus.textContent = '';
        setNotifyError('');

        if (notifySubmit) {
          notifySubmit.textContent = notifySubmit.getAttribute('data-submit-label') || labelNotify;
          notifySubmit.setAttribute('type', 'submit');
          notifySubmit.removeAttribute('data-drawer-close');
        }

        syncNotifySubmitState();
      }

      function closeFindStoreDrawer() {
        if (!findStoreDrawer) return;
        var closer = findStoreDrawer.querySelector('[data-drawer-close]');
        if (closer) closer.click();
      }

      function selectFindStoreItem(button) {
        if (!findStoreResultsList || !button) return;

        findStoreResultsList.querySelectorAll('[data-find-store-item]').forEach(function (item) {
          var selected = item === button;
          item.setAttribute('data-selected', selected ? 'true' : 'false');
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (findStoreStatus) {
          findStoreStatus.textContent = button.getAttribute('aria-label') || '';
        }

        var selectedName = button.querySelector('[data-find-store-name]');
        var selectedAddress = button.querySelector('[data-find-store-address]');
        var selectedLabel = selectedName ? selectedName.textContent.trim() : '';
        syncFindStoreTriggerLabel(selectedLabel);

        storedFindStoreSelection = {
          id: button.getAttribute('data-find-store-item-id') || '',
          name: selectedLabel,
          address: selectedAddress ? selectedAddress.textContent.trim() : '',
          query: findStoreInput ? findStoreInput.value.trim() : ''
        };
        writeStoredFindStoreSelection(storedFindStoreSelection);

        // Picking a store is the end of the flow now — no separate details CTA to
        // confirm on, so the drawer closes as soon as a selection is made.
        closeFindStoreDrawer();
      }

      async function performFindStoreSearch(query) {
        if (!findStoreForm || !findStoreInput) return;

        clearFindStoreFeedback();
        clearFindStoreResults();

        if (!currentVariant || !hasFindStoreAvailability(currentVariant)) {
          setFindStoreEmpty(findStoreForm.getAttribute('data-no-availability') || '');
          return;
        }

        if (findStoreAbortController) {
          findStoreAbortController.abort();
        }

        findStoreAbortController = window.AbortController ? new AbortController() : null;
        findStoreSearching = true;

        if (findStoreStatus) {
          findStoreStatus.textContent = findStoreForm.getAttribute('data-searching-status') || '';
        }

        try {
          var coordinates = await fetchLoqateCoordinates(
            query,
            findStoreAbortController ? findStoreAbortController.signal : undefined
          );

          if (!coordinates) {
            setFindStoreEmpty(findStoreForm.getAttribute('data-no-results') || '');
            return;
          }

          var stores = sortedStoreAvailabilities(currentVariant.store_availabilities, coordinates);
          if (!stores.length) {
            setFindStoreEmpty(findStoreForm.getAttribute('data-no-availability') || '');
            return;
          }

          renderFindStoreResults(stores);

          if (findStoreStatus) {
            findStoreStatus.textContent = findStoreForm.getAttribute('data-results-label') || '';
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (error && error.message) console.error(error.message);
          setFindStoreError(findStoreForm.getAttribute('data-error') || 'Unable to search');
        } finally {
          findStoreSearching = false;
          findStoreAbortController = null;
        }
      }

      function swymErrorMessage(error, fallback) {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error.message) return error.message;
        if (error.msg) return error.msg;
        if (error.error) return error.error;
        if (error.errorMessage) return error.errorMessage;
        return fallback;
      }

      // Swym silently drops the request (no callback fires) when an opt-in is sent
      // while "Mailing list check in popup" is off in its dashboard.
      function swymMailingListEnabled(swat) {
        var watchlist = swat && swat.retailerSettings && swat.retailerSettings.Watchlist;
        return Boolean(watchlist && watchlist.MailingListCheckInPopup);
      }

      function withSwymReady(onReady, onError) {
        if (window.__whittardSwymBisInstance && typeof window.__whittardSwymBisInstance.subscribeForProductAlert === 'function') {
          onReady(window.__whittardSwymBisInstance);
          return;
        }

        if (window._swat && typeof window._swat.subscribeForProductAlert === 'function') {
          window.__whittardSwymBisInstance = window._swat;
          onReady(window.__whittardSwymBisInstance);
          return;
        }

        var resolved = false;
        var timeout = window.setTimeout(function () {
          if (resolved) return;
          resolved = true;
          onError();
        }, 5000);

        function handleReady() {
          if (resolved) return;
          resolved = true;
          window.clearTimeout(timeout);
          onReady(window.__whittardSwymBisInstance);
        }

        document.addEventListener('whittard:swym:ready', handleReady, { once: true });
      }

      // Native action posts to /cart/add (HTML redirect); /cart/add.js
      // returns JSON instead. No Figma loading/error state, so disable
      // submits in flight and fall back to native submit on failure.
      function submitAddToCart(event) {
        event.preventDefault();

        var submitButtons = [cta].concat(Array.prototype.slice.call(stickySubmitButtons)).filter(Boolean);
        var cleanupPreparedSubmission = prepareCartSubmission();
        var fellBackToNativeSubmit = false;
        submitButtons.forEach(function (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });

        var formData = new FormData(form);
        var miniBagSectionId = window.MiniBag && typeof window.MiniBag.getSectionId === 'function'
          ? window.MiniBag.getSectionId()
          : 'mini-bag';
        formData.append('sections', miniBagSectionId);
        var addedSections = null;
        var addedProductId = null;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart_add_failed');
            return r.json();
          })
          .then(function (added) {
            addedSections = added && added.sections;
            addedProductId = added && added.product_id;
            // add.js returns the added line item, not the cart — no
            // item_count. `sections` is only rendered by the mutation
            // endpoints, not plain GET /cart.js, so fetch that separately
            // for the count fields and merge the two.
            return fetch('/cart.js');
          })
          .then(function (r) {
            if (!r.ok) throw new Error('cart_fetch_failed');
            return r.json();
          })
          .then(function (cart) {
            cart.sections = addedSections;
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, addedProductId: addedProductId } }));
            /* window.__drawerOpen, never a drawer:open event: assets/drawer.js claims
               __drawerControllerReady first, so drawer.liquid's fallback block — the only
               thing that ever listened for drawer:open — returns before registering it,
               and the bag silently never opened after an add. */
            if (typeof window.__drawerOpen === 'function') window.__drawerOpen('mini-bag');
          })
          .catch(function () {
            fellBackToNativeSubmit = true;
            form.submit();
          })
          .finally(function () {
            if (!fellBackToNativeSubmit) {
              cleanupPreparedSubmission();
            }
            submitButtons.forEach(function (button) {
              button.disabled = false;
              button.removeAttribute('aria-disabled');
            });
          });
      }

      function submitNotifyRequest(event) {
        event.preventDefault();
        if (!notifyForm || !notifyEmail) return;

        if (!currentVariant || warehouseAvailable(currentVariant)) {
          var unavailableMessage = notifyForm.getAttribute('data-error-unavailable') || labelUnavailable;
          setNotifyError(unavailableMessage);
          if (notifyStatus) notifyStatus.textContent = unavailableMessage;
          return;
        }

        if (typeof notifyEmail.reportValidity === 'function' && notifyEmail.reportValidity() === false) {
          syncNotifySubmitState();
          return;
        }

        notifySubmitting = true;
        setNotifyError('');
        if (notifyStatus) notifyStatus.textContent = '';
        syncNotifySubmitState();

        var baseUrl = notifyForm.getAttribute('data-product-url');
        var productPayload = {
          epi: currentVariant.id,
          empi: notifyForm.getAttribute('data-product-id'),
          du: baseUrl ? baseUrl + '?variant=' + encodeURIComponent(currentVariant.id) : window.location.href,
          iu: currentVariant.image || (notifyPrimaryImage ? notifyPrimaryImage.getAttribute('data-default-src') : ''),
          pr: currentVariant.price_value,
          dt: section.getAttribute('data-product-title') || document.title
        };

        var email = notifyEmail.value.trim();
        var addToMailingList = notifyMarketing && notifyMarketing.checked ? 1 : 0;
        var genericError = notifyForm.getAttribute('data-error-generic') || 'Unable to submit';

        function failNotify(message) {
          notifySubmitting = false;
          setNotifyError(message);
          if (notifyStatus) notifyStatus.textContent = message;
          syncNotifySubmitState();
        }

        withSwymReady(
          function (swat) {
            if (!swat || typeof swat.subscribeForProductAlert !== 'function') {
              failNotify(genericError);
              return;
            }

            // Never leave the drawer stuck on the loading label if Swym never calls back.
            var settled = false;
            var settleTimeout = window.setTimeout(function () {
              if (settled) return;
              settled = true;
              failNotify(genericError);
            }, 8000);

            swat.subscribeForProductAlert(
              email,
              'email',
              productPayload,
              function () {
                if (settled) return;
                settled = true;
                window.clearTimeout(settleTimeout);
                notifySubmitting = false;
                if (notifyDescription) {
                  notifyDescription.classList.add('hidden');
                }
                if (notifySuccess) {
                  notifySuccess.classList.remove('hidden');
                }
                if (notifyEmail) {
                  notifyEmail.value = '';
                  notifyEmail.dispatchEvent(new Event('input', { bubbles: true }));
                  notifyEmail.dispatchEvent(new Event('change', { bubbles: true }));
                  notifyEmail.blur();
                }
                if (notifyStatus) {
                  notifyStatus.textContent = notifyForm.getAttribute('data-success-status') || '';
                }
                setNotifyError('');

                if (notifySubmit) {
                  notifySubmit.textContent =
                    notifySubmit.getAttribute('data-submit-label') || labelNotify;

                  notifySubmit.setAttribute('type', 'submit');
                  notifySubmit.removeAttribute('data-drawer-close');
                }

                syncNotifySubmitState();

                if (notifySuccess && typeof notifySuccess.focus === 'function') {
                  notifySuccess.focus({ preventScroll: true });
                }
              },
              function (error) {
                if (settled) return;
                settled = true;
                window.clearTimeout(settleTimeout);
                failNotify(swymErrorMessage(error, genericError));
              },
              addToMailingList && swymMailingListEnabled(swat) ? 1 : 0,
              'backinstock'
            );
          },
          function () {
            failNotify(genericError);
          }
        );
      }

      // Moves the PDP option underline to the hovered, focused, or selected item on desktop.
      function getOptionIndicatorItem(target) {
        return target.closest('label, a, button, span[aria-current]');
      }

      function setOptionIndicator(item) {
        var group = item && item.closest('[data-option-underline-group]');
        if (!group || !picker || !picker.contains(group)) return;

        // A hover, focus, or selection supersedes any pending leave-reset for this
        // group — cancel it so the indicator can't snap back to the old :checked item.
        if (group._optionResetFrame) {
          cancelAnimationFrame(group._optionResetFrame);
          group._optionResetFrame = 0;
        }

        group.style.setProperty('--option-indicator-x', item.offsetLeft + 'px');
        group.style.setProperty('--option-indicator-w', item.offsetWidth + 'px');
        group.setAttribute('data-option-indicator-ready', '');
        group.setAttribute('data-option-indicator-visible', 'true');
      }

      function resetOptionIndicator(group) {
        if (!group) return;

        var checked = group.querySelector('input[data-option-position]:checked');
        var item = checked ? checked.closest('label, button') : group.querySelector('span[aria-current]');

        if (item) {
          setOptionIndicator(item);
        } else {
          group.setAttribute('data-option-indicator-ready', '');
          group.setAttribute('data-option-indicator-visible', 'false');
        }
      }

      function refreshOptionIndicators() {
        if (!picker) return;

        picker.querySelectorAll('[data-option-underline-group]').forEach(function (group) {
          resetOptionIndicator(group);
        });
      }

      function handleOptionIndicatorEnter(event) {
        var item = getOptionIndicatorItem(event.target);
        if (item) setOptionIndicator(item);
      }

      function handleOptionIndicatorLeave(event) {
        var group = event.target.closest('[data-option-underline-group]');
        if (!group) return;
        if (event.relatedTarget && group.contains(event.relatedTarget)) return;
        var isFocusLeave = event.type === 'focusout';

        // Windows/Chrome can paint between pointerdown/focusout and the radio's
        // later click/change. Ignore that transient focusout while the group is still
        // hovered or focused, or :checked points at the old selection for one frame.
        if (group._optionResetFrame) cancelAnimationFrame(group._optionResetFrame);
        group._optionResetFrame = requestAnimationFrame(function () {
          group._optionResetFrame = 0;
          if (isFocusLeave && (group.matches(':hover') || group.contains(document.activeElement))) return;
          resetOptionIndicator(group);
        });
      }

      if (picker) {
        picker.addEventListener('pointerover', handleOptionIndicatorEnter);
        picker.addEventListener('focusin', handleOptionIndicatorEnter);
        picker.addEventListener('focusout', handleOptionIndicatorLeave);
        picker.querySelectorAll('[data-option-underline-group]').forEach(function (group) {
          group.addEventListener('pointerleave', handleOptionIndicatorLeave);
        });
      }

      function update() {
        var selection = currentSelection();
        currentSelectionState = selection.slice();

        if (picker) {
          picker.querySelectorAll('[data-selected-value]').forEach(function (label) {
            var index = parseInt(label.getAttribute('data-option-position'), 10) - 1;
            label.textContent = selection[index] != null ? selection[index] : '';
          });
        }

        var sizeReady = sizeAxisSelected();
        var variant = sizeReady
          ? (variants.length === 1 ? variants[0] : matchVariant(selection))
          : null;
        currentVariant = variant;

        // Feature A — reactive intro: variant's own intro, else the product intro. Rebuilt
        // with safe DOM (split on newlines → text nodes + <br>), never innerHTML.
        // Gate on a real variant so the server-rendered first-paint intro (keyed off
        // current_variant) persists until an actual selection — mirroring the gallery
        // highlight's null no-op, and avoiding a variant→product flash on a fresh
        // size-axis PDP where the initial update() runs with variant === null.
        if (introEl && variant) {
          var introText = variant.variant_intro
            ? variant.variant_intro
            : (introEl.getAttribute('data-product-intro') || '');
          while (introEl.firstChild) introEl.removeChild(introEl.firstChild);
          var introSegments = introText.split('\n');
          for (var i = 0; i < introSegments.length; i++) {
            if (i > 0) introEl.appendChild(document.createElement('br'));
            introEl.appendChild(document.createTextNode(introSegments[i]));
          }
          introEl.classList.toggle('hidden', introText === '');
        }

        // Reactive specs: reveal the variant's block, else the product fallback. No null-variant gate — an unselected picker must not assert a specific variant's data
        if (specsBlocks.length) {
          var specsTarget = (variant && section.querySelector('[data-specs-variant="' + variant.id + '"]'))
            || section.querySelector('[data-specs-fallback]');
          for (var s = 0; s < specsBlocks.length; s++) {
            specsBlocks[s].classList.toggle('hidden', specsBlocks[s] !== specsTarget);
          }
          // Collapse the accordion when neither the variant nor the product has specs
          if (specsAccordion) specsAccordion.classList.toggle('hidden', !specsTarget);
        }

        // Feature B — notify the gallery + zoom overlay of the selected variant.
        section.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));

        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (availability) {
            availability.textContent = warehouseAvailable(variant)
              ? availability.getAttribute('data-avail-in')
              : availability.getAttribute('data-avail-out');
          }
          if (priceCurrent) {
            priceCurrent.textContent = variant.price;
            priceCurrent.classList.toggle('text-semantic-red', !!variant.compare_at_price);
          }
          if (priceCompare) {
            if (variant.compare_at_price) {
              priceCompare.textContent = variant.compare_at_price;
              priceCompare.classList.remove('hidden');
            } else {
              priceCompare.classList.add('hidden');
            }
          }

          if (cta) {
            if (warehouseAvailable(variant)) {
              cta.textContent = labelAdd;
              cta.removeAttribute('aria-disabled');
              cta.disabled = false;
              syncActionMode('add');
            } else {
              cta.textContent = labelUnavailable;
              cta.setAttribute('aria-disabled', 'true');
              cta.disabled = true;
              syncActionMode('notify');
            }
          }
        } else {
          if (idInput) idInput.value = '';
          if (cta) {
            cta.textContent = sizeReady ? labelChoose : labelChooseSize;
            cta.setAttribute('aria-disabled', 'true');
            cta.disabled = true;
            syncActionMode('choose');
          }
        }

        // Mirror the variant id onto the value attribute (never blank) so ReCharge can infer the product form and update
        if (idInput) idInput.setAttribute('value', idInput.value || subscriptionFallbackId);

        clearTimeout(findStoreDebounceTimer);
        if (findStoreAbortController) {
          findStoreAbortController.abort();
          findStoreAbortController = null;
        }
        findStoreSearching = false;
        syncFindStoreTrigger(variant);
        clearFindStoreResults();
        clearFindStoreFeedback();
        syncFindStoreTriggerLabel(storedFindStoreSelection ? storedFindStoreSelection.name : '');
        syncBuyBoxNote(variant);
        syncStickySummary(selection, variant);
        syncStickySubscriptionSummary();
        syncNotifySummary(selection, variant);
        syncNotifySubmitState();
        if (window.StickyAtb) window.StickyAtb.refresh(section);
        if (window.BuyPanelSticky) window.BuyPanelSticky.refresh(section);
        refreshOptionIndicators();
      }

      function syncUrl(variantId) {
        if (!history.replaceState) return;
        var params = new URLSearchParams(location.search);
        if (String(params.get('variant')) === String(variantId)) return;
        params.set('variant', variantId);
        history.replaceState({}, '', location.pathname + '?' + params.toString());
      }

      function preselectFromUrl() {
        if (!picker) return;
        var requested = new URLSearchParams(location.search).get('variant');
        if (!requested) return;
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(requested)) {
            match = variants[i];
            break;
          }
        }
        if (!match) return;
        for (var p = 0; p < match.options.length; p++) {
          var input = picker.querySelector(
            'input[data-option-position="' + (p + 1) + '"][value="' + CSS.escape(match.options[p]) + '"]'
          );
          if (input) input.checked = true;
        }
      }

      stickyOptionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!picker) return;
          var position = button.getAttribute('data-option-position');
          if (!position) return;
          var selector = '[data-option-position="' + CSS.escape(position) + '"]';
          var target = picker.querySelector('[data-option-group]' + selector);
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () {
            var focusTarget =
              target.querySelector('input' + selector + ':checked') ||
              target.querySelector('input' + selector) ||
              target.querySelector('a, button');

            if (focusTarget) {
              focusTarget.focus({ preventScroll: true });
            }
            resetOptionIndicator(target);
          }, 350);
        });
      });

      // TASK-54725: a "Choose a size" sticky submit button is a native disabled
      // <button> (aria-disabled:pointer-events-none too), so it never receives
      // its own click — the event falls through to this wrap instead, landing
      // with event.target === wrap. The qty stepper is a real, enabled control,
      // so a click on it targets itself and is correctly ignored here.
      stickySubmitWraps.forEach(function (wrap) {
        wrap.addEventListener('click', function (event) {
          if (event.target !== wrap) return;
          if (!sizeAxisGroup || sizeAxisSelected()) return;
          sizeAxisGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () {
            var focusTarget =
              sizeAxisGroup.querySelector('input[data-option-position]:checked') ||
              sizeAxisGroup.querySelector('input[data-option-position]') ||
              sizeAxisGroup.querySelector('a, button');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
            resetOptionIndicator(sizeAxisGroup);
          }, 350);
        });
      });

      if (stickySubscriptionJump) {
        stickySubscriptionJump.addEventListener('click', function () {
          scrollToSubscriptionWidget();
        });
      }

      if (picker) {
        picker.addEventListener('change', function (event) {
          if (!event.target.matches('input[data-option-position]')) return;
          update();
          var matched = matchVariant(currentSelection());
          if (matched) syncUrl(matched.id);
        });
      }

      notifyOpenButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          resetNotifyDrawer();
          syncNotifySummary(currentSelectionState, currentVariant);
          syncNotifySubmitState();
        });
      });

      oosNotifyButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var optionPosition = parseInt(button.getAttribute('data-option-position'), 10) - 1;
          var optionValue = button.getAttribute('data-oos-value');
          var selection = currentSelection();
          if (!selection.length && currentSelectionState.length) {
            selection = currentSelectionState.slice();
          }
          if (optionPosition >= 0 && optionValue) {
            selection[optionPosition] = optionValue;
          }
          var oosVariant = matchVariant(selection);
          if (!oosVariant) {
            var oosId = button.getAttribute('data-oos-variant-id');
            if (oosId) {
              for (var i = 0; i < variants.length; i++) {
                if (String(variants[i].id) === String(oosId)) {
                  oosVariant = variants[i];
                  break;
                }
              }
            }
          }
          if (oosVariant) {
            currentVariant = oosVariant;
            currentSelectionState = oosVariant.options.slice();
          } else {
            currentVariant = null;
            currentSelectionState = selection.slice();
          }
          resetNotifyDrawer();
          syncNotifySummary(currentSelectionState, currentVariant);
          syncNotifySubmitState();
        });
      });

      findStoreOpenButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          resetFindStoreDrawer();
          syncFindStoreTrigger(currentVariant);

          if (
            storedFindStoreSelection &&
            storedFindStoreSelection.query &&
            findStoreInput &&
            hasFindStoreAvailability(currentVariant)
          ) {
            findStoreInput.value = storedFindStoreSelection.query;

            var findStoreFloatField = findStoreInput.closest('[data-float-field]');
            if (findStoreFloatField) findStoreFloatField.classList.add('is-floated');

            performFindStoreSearch(storedFindStoreSelection.query);
          }
        });
      });

      if (notifyForm) {
        notifyForm.addEventListener('submit', submitNotifyRequest);
      }

      if (findStoreForm) {
        // Search runs as-you-type off the input listener below; this only stops the
        // single-field form's native implicit submission (Enter key) from reloading
        // the page now that there is no submit button.
        findStoreForm.addEventListener('submit', function (event) {
          event.preventDefault();
        });
      }

      form.addEventListener('submit', submitAddToCart);

      form.addEventListener('change', function (event) {
        if (
          event.target.closest('[data-buy-box-app-blocks]') ||
          event.target.matches(
            'input[name="selling_plan"], select[name="selling_plan"], input[name*="selling_plan"], select[name*="selling_plan"], select[name="rc_plan"], select[name*="rc_plan"]'
          )
        ) {
          syncStickySubscriptionSummarySoon();
        }
      });

      if (notifyEmail) {
        ['input', 'blur', 'change'].forEach(function (eventName) {
          notifyEmail.addEventListener(eventName, function () {
            setNotifyError('');
            syncNotifySubmitState();
          });
        });
      }

      if (findStoreInput) {
        findStoreInput.addEventListener('input', function () {
          var query = findStoreInput.value.trim();
          clearTimeout(findStoreDebounceTimer);

          if (findStoreAbortController) {
            findStoreAbortController.abort();
            findStoreAbortController = null;
          }
          findStoreSearching = false;

          if (query === '') {
            clearFindStoreResults();
            clearFindStoreFeedback();
            syncFindStoreTriggerLabel('');
            return;
          }

          clearFindStoreFeedback();
          findStoreDebounceTimer = setTimeout(function () {
            performFindStoreSearch(query);
          }, 300);
        });
      }

      if (findStoreResultsList) {
        findStoreResultsList.addEventListener('click', function (event) {
          var button = event.target.closest('[data-find-store-item]');
          if (!button) return;
          selectFindStoreItem(button);
        });
      }

      if (findStoreDrawer && findStoreDrawerId) {
        document.addEventListener('drawer:close', function (event) {
          if (event.detail && event.detail.id === findStoreDrawerId) {
            resetFindStoreDrawer();
          }
        });
      }
      
      function getAnchorScrollOffset() {
        return header ? header.offsetHeight : 0;
      }

      function scrollToAnchorTarget(target) {
        var targetTop = target.getBoundingClientRect().top + window.scrollY - getAnchorScrollOffset();

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      }

      moreInfoLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (!aboutProductWrapper) return;

          var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
          var hasAboutContent = Boolean(aboutProductCard && aboutProductCard.textContent.trim());
          var scrollTarget = hasAboutContent ? aboutProductCard : aboutProductWrapper;
          var offset = hasAboutContent ? (isDesktop ? 96 : 48) : 0;

          event.preventDefault();

          smoothScrollTo(
            Math.max(scrollTarget.getBoundingClientRect().top + window.scrollY - offset, 0)
          );

          if (history.pushState) {
            history.pushState(null, '', '#about-product');
          } else {
            window.location.hash = 'about-product';
          }
        });
      });

      reviewLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (!reviewsTarget) return;

          event.preventDefault();

          reviewsTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          if (history.pushState) {
            history.pushState(null, '', '#reviews');
          } else {
            window.location.hash = 'reviews';
          }
        });
      });


      preselectFromUrl();
      update();

      findStoreTriggerLabels.forEach(function (label) {
        label.classList.remove('opacity-0');
      });

      if (window.MutationObserver && buyBoxAppBlocks) {
        new MutationObserver(function () {
          bindRechargeStickySummaryListeners();
          syncStickySubscriptionSummarySoon();
        }).observe(buyBoxAppBlocks, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });
      }

      bindRechargeStickySummaryListeners();

      window.setTimeout(function () {
        bindRechargeStickySummaryListeners();
        syncStickySubscriptionSummarySoon();
      }, 500);

      window.setTimeout(function () {
        bindRechargeStickySummaryListeners();
        syncStickySubscriptionSummarySoon();
      }, 1500);

      // Resize + height-change handling for the sticky buy-panel offset now lives in
      // assets/product-sticky-atb.js's BuyPanelSticky module (its own resize
      // listener + a ResizeObserver on every [data-buy-panel-content]).

      window.addEventListener('resize', refreshOptionIndicators, { passive: true });
    });
  })();

  (function () {
    var ticking = false;
    function setAboutMediaState(media, state) {
      if (!media) return;
      media.removeAttribute('data-about-media-fixed');
      media.removeAttribute('data-about-media-released');
      if (state === 'fixed') {
        media.setAttribute('data-about-media-fixed', 'true');
      }
      if (state === 'released') {
        media.setAttribute('data-about-media-released', 'true');
      }
    }

    function syncAboutMediaPosition() {
      document.querySelectorAll('[data-product-section]').forEach(function (section) {
        var previousSection = section.querySelector('[data-product-header-block]');
        var aboutSection = section.querySelector('[data-about-product-target]');
        var afterAboutSection = section.querySelector('[data-after-about-overlap]');
        if (!previousSection || !aboutSection) return;
        var isMediaOnly = aboutSection.hasAttribute('data-about-media-only');
        var aboutMedia = isMediaOnly ? aboutSection : aboutSection.querySelector('[data-about-product-media]');
        if (!aboutMedia) return;
        var previousRect = previousSection.getBoundingClientRect();
        var aboutRect = aboutSection.getBoundingClientRect();
        var afterAboutRect = afterAboutSection ? afterAboutSection.getBoundingClientRect() : null;
        var previousHasLeftViewport = previousRect.bottom <= 0;
        var aboutHasReachedTop = aboutRect.top <= 0;
        var previousHasEnteredViewportAgain = previousRect.bottom > 0;
        var afterAboutHasReachedTop = afterAboutRect ? afterAboutRect.top <= 0 : false;
        if (afterAboutHasReachedTop) {
          setAboutMediaState(aboutMedia, 'released');
          return;
        }
        if (
          (aboutHasReachedTop || previousHasLeftViewport) &&
          !previousHasEnteredViewportAgain
        ) {
          setAboutMediaState(aboutMedia, 'fixed');
          return;
        }
        setAboutMediaState(aboutMedia, 'normal');
      });
    }

    function requestAboutMediaPositionSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncAboutMediaPosition();
      });
    }

    syncAboutMediaPosition();
    window.addEventListener('scroll', requestAboutMediaPositionSync, { passive: true });
    window.addEventListener('resize', requestAboutMediaPositionSync, { passive: true });
    window.addEventListener('orientationchange', requestAboutMediaPositionSync, { passive: true });
    window.addEventListener('load', requestAboutMediaPositionSync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  /* Promo banner message rotation. Figma "FADE IN / OUT MESSAGE" (20452:100828):
     STEP 1 the current message fades out (EB, 0.3s) after a 3s hold; STEP 2 the next
     fades in (EB, 0.3s) a further 0.3s later, i.e. once the outgoing fade completes.
     Cycle = 3000 + 300 + 300 = 3600ms, which leaves each message fully visible for
     exactly the 3s the node specifies.

     HOLD_MS/FADE_MS mirror --duration-3000 and --duration-a3 in src/css/theme.css.
     A timeout rather than transitionend, because transitionend never fires under
     prefers-reduced-motion where the transition is 0ms — the hand-off has to happen
     either way. Same reasoning as PROMO_SLIDE_MS in snippets/mini-bag-ui-script.liquid.

     All visual state is CSS; this file only ever writes the state attribute. */
  ;(function () {
    var HOLD_MS = 3000;
    var FADE_MS = 300;
    var CYCLE_MS = HOLD_MS + FADE_MS + FADE_MS;

    var intervalIds = [];

    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    function clearAll() {
      intervalIds.forEach(function (id) {
        window.clearInterval(id);
      });
      intervalIds = [];
    }

    function initBanners() {
      clearAll();

      document.querySelectorAll('[data-promo-banner]').forEach(function (root) {
        var messages = Array.prototype.slice.call(
          root.querySelectorAll('[data-promo-banner-message]')
        );

        if (messages.length <= 1) return;

        /* Seed from the DOM, not from 0: the theme editor's section-load event fires for
           ANY section the merchant edits, so this re-init can land on a banner whose own
           DOM was never replaced and is mid-cycle. Assuming 0 would promote the wrong
           message next and leave two of them 'current' in the same grid cell, overlapping,
           until the cycle walked back into sync. */
        var index = messages.findIndex(function (message) {
          return message.getAttribute('data-promo-state') === 'current';
        });

        if (index < 0) index = 0;

        function advance() {
          var current = messages[index];

          index = (index + 1) % messages.length;

          var next = messages[index];

          current.setAttribute('data-promo-state', 'outgoing');

          function handOff() {
            if (current.getAttribute('data-promo-state') === 'outgoing') {
              current.setAttribute('data-promo-state', 'hidden');
            }
            next.setAttribute('data-promo-state', 'current');
          }

          /* Under reduced motion the fade is already 0ms, so the outgoing message is
             invisible the instant it is marked 'outgoing'. Still waiting FADE_MS before
             promoting the next one would leave the bar empty for 300ms — a hard blink,
             the opposite of what the media query is for. Hand over synchronously instead,
             so the swap is genuinely instant as §4.13 AC-5 describes. */
          if (reducedMotion && reducedMotion.matches) {
            handOff();
          } else {
            window.setTimeout(handOff, FADE_MS);
          }
        }

        function start() {
          stop();
          var intervalId = window.setInterval(advance, CYCLE_MS);
          root.__promoBannerIntervalId = intervalId;
          intervalIds.push(intervalId);
        }

        function stop() {
          if (!root.__promoBannerIntervalId) return;
          window.clearInterval(root.__promoBannerIntervalId);
          root.__promoBannerIntervalId = null;
        }

        /* WCAG 2.2.2 (Pause, Stop, Hide) — auto-updating content needs a way to stop it.
           Bound once per element: initBanners re-runs on every theme-editor section load,
           and only the interval should be rebuilt, not the listeners. Same as the promo
           ticker in snippets/mini-bag-ui-script.liquid, minus its focusin/focusout pair:
           the bar holds no focusable element (no CTA, by design), so those can never fire
           here. Pointer users get a pause; this is a partial 2.2.2 mitigation, not full
           conformance. */
        if (!root.__promoBannerBound) {
          root.__promoBannerBound = true;
          root.addEventListener('mouseenter', stop);
          root.addEventListener('mouseleave', start);
        }

        start();
      });
    }

    initBanners();

    /* The theme editor replaces a section's DOM wholesale, which strips the nodes
       this controller holds references to. Re-init on the platform's own event —
       same pattern as snippets/store-finder-list.liquid and sections/cms-page.liquid. */
    document.addEventListener('shopify:section:load', initBanners);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail-map"]) return;
  try {
    
  ;(function () {
    // Both figures are documented in this section's doc block at the top of
    // the file. The adapter's setZoom is RELATIVE, so the target is expressed
    // as a delta from the zoom the adapter itself starts at.
    var ADAPTER_INITIAL_ZOOM = 6;
    var DETAIL_ZOOM = 15;

    function applyCamera(mapEl) {
      // Guarded per element, so a second map-ready on the same element cannot
      // apply the relative zoom delta twice.
      if (mapEl.__storeDetailMapCentred) return;

      var adapter = window.WhittardMapAdapter;
      if (!adapter) return;

      var lat = Number(mapEl.getAttribute('data-store-detail-map-lat'));
      var lng = Number(mapEl.getAttribute('data-store-detail-map-lng'));
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

      mapEl.__storeDetailMapCentred = true;

      // One pin, no clustering: setClusteringEnabled is deliberately never
      // called, so the adapter attaches the marker to the map directly.
      if (typeof adapter.setMarkers === 'function') {
        adapter.setMarkers([{
          handle: '',
          lat: lat,
          lng: lng,
          name: mapEl.getAttribute('data-store-detail-map-name') || ''
        }]);
      }

      if (typeof adapter.setZoom === 'function') {
        adapter.setZoom(DETAIL_ZOOM - ADAPTER_INITIAL_ZOOM);
      }

      // animate:false — the band must open on the store, not pan to it from
      // the adapter's UK-wide default centre.
      if (typeof adapter.panTo === 'function') {
        adapter.panTo(lat, lng, { animate: false });
      }
    }

    // Enabled only once the map is interactive, so neither control is ever a
    // dead control while the SDK loads or after it has failed.
    function enableControls(mapEl) {
      var controls = mapEl.querySelectorAll(
        '[data-store-detail-map-zoom-in], [data-store-detail-map-zoom-out]'
      );
      Array.prototype.forEach.call(controls, function (control) { control.disabled = false; });
    }

    // Delegated at document level, with no top-level DOM query: nothing here
    // throws on a page without the band, and the theme editor replacing the
    // section rebuilds the element (and its guard flag) and re-fires map-ready.
    document.addEventListener('store-finder:map-ready', function (event) {
      var target = event.target;
      var mapEl = target && target.closest ? target.closest('[data-store-detail-map]') : null;
      if (!mapEl) return;

      applyCamera(mapEl);
      enableControls(mapEl);
    });

    document.addEventListener('click', function (event) {
      var zoomIn = event.target.closest('[data-store-detail-map-zoom-in]');
      var zoomOut = zoomIn ? null : event.target.closest('[data-store-detail-map-zoom-out]');
      if (!zoomIn && !zoomOut) return;

      // Resolved at the point of use, never at the top level — the section
      // bundle runs before the snippet bundle that defines it (FAILS §3).
      var adapter = window.WhittardMapAdapter;
      if (!adapter || typeof adapter.setZoom !== 'function') return;

      adapter.setZoom(zoomIn ? 1 : -1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-finder"]) return;
  try {
    
  ;(function () {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    // The ONE sanctioned document-level lookup in this feature: the surface
    // is rendered outside the section root, so it is not a descendant and
    // cannot be reached by a scoped query (orch §4.8.4). Every other lookup
    // below is scoped to this element or to the section beside it.
    var surface = document.querySelector('[data-store-finder-fullscreen]');
    if (!surface) return;

    var mount = surface.querySelector('[data-store-finder-fullscreen-mount]');
    if (!mount || (surface.parentElement && !surface.parentElement.querySelector('[data-store-finder]'))) return;

    var isOpen = false;
    var returnFocusTo = null;
    var scrollY = 0;
    var homeParent = null;
    var homeNextSibling = null;

    // Resolved fresh on every call, not cached: unlike `surface`/`mount` (both
    // live in layout/theme.liquid, outside any section, so a section reload
    // never touches them), this section IS the exact node the theme editor
    // replaces wholesale on shopify:section:load. A cached reference here
    // would keep pointing at the detached pre-reload section forever — this
    // file has no window.init.../shopify:section:load hook of its own to
    // refresh a cached value, unlike its sibling files in this feature.
    function sectionEl() {
      return surface.parentElement ? surface.parentElement.querySelector('[data-store-finder]') : null;
    }

    function mapEl() {
      var section = sectionEl();
      return (section && section.querySelector('[data-store-finder-map]')) || mount.querySelector('[data-store-finder-map]');
    }

    function toggleControls(open) {
      var section = sectionEl();
      var openBtn = surface.querySelector('[data-store-finder-fullscreen-open]') || (section && section.querySelector('[data-store-finder-fullscreen-open]'));
      var closeBtn = surface.querySelector('[data-store-finder-fullscreen-close]') || (section && section.querySelector('[data-store-finder-fullscreen-close]'));
      if (openBtn) openBtn.hidden = open;
      if (closeBtn) closeBtn.hidden = !open;
    }

    function open() {
      if (isOpen) return;
      var element = mapEl();
      if (!element) return;

      isOpen = true;
      returnFocusTo = document.activeElement;
      scrollY = window.scrollY;

      // Remember exactly where the map came from so close() restores DOM
      // order rather than appending it back at the end of the column.
      homeParent = element.parentElement;
      homeNextSibling = element.nextElementSibling;

      mount.appendChild(element);
      // The column reserves 487/718px; in the surface it must fill the
      // viewport box instead. Inline because the state is JS-driven.
      element.style.minHeight = '100%';
      element.style.height = '100%';

      // Resize/recentre before the surface becomes visible, not after: without
      // this dispatch the canvas keeps its pre-fullscreen dimensions and
      // renders clipped (A&I-4, AC-19); firing it here rather than below
      // means it's already settled by the time the surface is shown.
      var openSection = sectionEl();
      if (openSection) {
        openSection.dispatchEvent(new CustomEvent('store-finder:fullscreen-changed', {
          bubbles: true,
          detail: { open: true }
        }));
      }

      surface.removeAttribute('aria-hidden');
      surface.removeAttribute('inert');
      surface.classList.remove('opacity-0', 'pointer-events-none');
      surface.classList.add('opacity-100', 'pointer-events-auto');
      // Shared counter with assets/drawer.js (window.WhittardScrollLock), not a direct
      // style set: a header drawer opened while this surface is also open would
      // otherwise clear body.style.overflow unconditionally on its own close, unlocking
      // scroll while this surface is still visually covering the page.
      if (window.WhittardScrollLock) window.WhittardScrollLock.lock();

      toggleControls(true);

      var closeBtn = surface.querySelector('[data-store-finder-fullscreen-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      var element = mount.querySelector('[data-store-finder-map]');
      if (element && homeParent) {
        element.style.minHeight = '';
        element.style.height = '';
        // homeNextSibling was captured at open() time; if the theme editor swaps
        // this section (shopify:section:load) while the surface is open, it can
        // be a stale node no longer inside homeParent, and insertBefore throws.
        // Falling back to appendChild keeps the restore itself from throwing and
        // skipping the WhittardScrollLock.unlock() call below.
        try {
          homeParent.insertBefore(element, homeNextSibling);
        } catch (e) {
          homeParent.appendChild(element);
        }
      }

      // Resize/recentre while the map is still hidden behind the surface, not
      // after: dispatching this below scrollTo left the map visibly catching
      // up to its inline size once the page had already scrolled it back
      // into view.
      var closeSection = sectionEl();
      if (closeSection) {
        closeSection.dispatchEvent(new CustomEvent('store-finder:fullscreen-changed', {
          bubbles: true,
          detail: { open: false }
        }));
      }

      surface.setAttribute('aria-hidden', 'true');
      surface.setAttribute('inert', '');
      surface.classList.remove('opacity-100', 'pointer-events-auto');
      surface.classList.add('opacity-0', 'pointer-events-none');
      if (window.WhittardScrollLock) window.WhittardScrollLock.unlock();

      toggleControls(false);

      window.scrollTo(0, scrollY);
      if (returnFocusTo && typeof returnFocusTo.focus === 'function') returnFocusTo.focus();
      returnFocusTo = null;
    }

    // Delegated so the controls keep working after the map column that owns
    // them is moved between the section and the surface.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-store-finder-fullscreen-open]')) {
        open();
        return;
      }
      if (event.target.closest('[data-store-finder-fullscreen-close]')) close();
    });

    // Local Tab trap, modelled on the inline trap in assets/drawer.js. The
    // global focus-trap utility is deliberately not loaded per-section.
    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        surface.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!surface.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  })(); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
;(function () {

  function getBarWidth(index, total) {
    if (total <= 1) return 0;
    return (index / (total - 1)) * 100;
  }

  function initTimeline(root) {
    var total    = parseInt(root.dataset.tlCount, 10);
    var duration = parseInt(root.dataset.tlDuration, 10) || 2000;
    if (!total || total < 2) return;

    var currentIndex  = 0;
    var isAnimating   = false;
    var paused        = false;
    var timer         = null;
    var labelCenters  = null;

    var slideContents = root.querySelectorAll('[data-tl-slide]');
    var slideImgs     = root.querySelectorAll('[data-tl-slide-img]');
    var slideMobImgs  = root.querySelectorAll('[data-tl-slide-img-mobile]');
    var labels        = root.querySelectorAll('[data-tl-label]');
    var progressBar   = root.querySelector('[data-tl-progress]');
    var announce      = root.querySelector('[data-tl-announce]');

    // On md+, measure the centre of each label relative to the bar track so the
    // bar endpoint lands under the label text rather than at an even percentage.
    function computeLabelCenters() {
      if (!progressBar || !window.matchMedia('(min-width: 1024px)').matches) {
        labelCenters = null;
        return;
      }
      var trackRect = progressBar.parentElement.getBoundingClientRect();
      if (trackRect.width === 0) { labelCenters = null; return; }
      labelCenters = [];
      labels.forEach(function (label) {
        var rect   = label.getBoundingClientRect();
        var center = rect.left + rect.width / 2 - trackRect.left;
        labelCenters.push((center / trackRect.width) * 100);
      });
    }

    // First and last milestones use the percentage formula (0 % / 100 %).
    // Middle milestones on desktop use the measured label centre.
    function getTargetWidth(index) {
      if (index > 0 && index < total - 1 && labelCenters && labelCenters[index] !== undefined) {
        return labelCenters[index];
      }
      return getBarWidth(index, total);
    }

    function setActive(index) {
      slideContents.forEach(function (el) {
        var active = parseInt(el.dataset.tlSlide, 10) === index;
        el.classList.toggle('is-active', active);
        if (active) {
          el.removeAttribute('aria-hidden');
          el.removeAttribute('inert');
        } else {
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('inert', '');
        }
      });

      slideImgs.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.dataset.tlSlideImg, 10) === index);
      });
      slideMobImgs.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.dataset.tlSlideImgMobile, 10) === index);
      });

      labels.forEach(function (el) {
        var labelIndex = parseInt(el.dataset.tlLabel, 10);
        el.classList.toggle('is-active', labelIndex === index);
        el.classList.toggle('is-past', labelIndex < index);
      });

      if (announce) {
        var headingEl = slideContents[index] ? slideContents[index].querySelector('h2') : null;
        announce.textContent = (headingEl || labels[index])
          ? (headingEl || labels[index]).textContent.trim()
          : '';
      }

      currentIndex = index;
    }

    function advanceBar(nextIndex) {
      if (!progressBar) return;
      if (nextIndex === 0) {
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';
        progressBar.getBoundingClientRect();
        progressBar.style.transition = '';
      }
      progressBar.style.width = getTargetWidth(nextIndex) + '%';
    }

    function cycle() {
      if (isAnimating || paused) return;
      isAnimating = true;
      var next = (currentIndex + 1) % total;

      advanceBar(next);

      // On reset (last → first) the bar jumps to 0 % instantly — no animation to wait for.
      var barWait = next === 0 ? 0 : duration;

      timer = setTimeout(function () {
        if (paused) { isAnimating = false; return; }
        setActive(next);
        timer = setTimeout(function () {
          isAnimating = false;
          cycle();
        }, duration);
      }, barWait);
    }

    // WCAG 2.2.2 — pause auto-rotation when the user moves focus into the section.
    function pauseTimeline() {
      paused = true;
      clearTimeout(timer);
      isAnimating = false;
    }

    function resumeTimeline() {
      if (!paused) return;
      paused = false;
      cycle();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    computeLabelCenters();
    window.addEventListener('resize', computeLabelCenters);

    root.addEventListener('focusin',  pauseTimeline);
    root.addEventListener('focusout', resumeTimeline);

    if (progressBar) {
      progressBar.style.width = getTargetWidth(0) + '%';
    }

    timer = setTimeout(function () {
      cycle();
    }, duration);
  }

  document.querySelectorAll('[data-timeline]').forEach(initTimeline);

}());

  } catch(e) { console.error(e); }
})();
})();
